/* This variable is for filter unique value from customization */ 
var searchSpringUniqueTag = UniqueTagList;

var searchSpringUniqueTagArr = searchSpringUniqueTag.split(',').filter(value => value !== "");

/* Flag for apply customization unique logic */
var searchSpringUniqueTagArrLogic = enableUniqueFilter;

/* Flag for search page filter count */
var searchPageCountflag = true;
/* Flag for collection page filter count */
var collectionPageCountflag = true;

/* array for exclude filter from search page */
var arrFilterRemoveSearch = [];

/* Search-Page constant */
var searchPageRedirection = searchPageUrlHandle;

var featuredProductArr = [];

var suggestApiFlagNoRes = false;
var searchResultFlagNoRes = false;

/* ==============  Function for validate and create cookie for Search Spring Start   ============== */

function getSearchSpringCookie(cookieName) {
    var cookies = document.cookie.split(';');
    for(var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName + '=') === 0) {         
            return cookie.substring(cookieName.length + 1, cookie.length);
        }
    }
    return null;
}

function setSearchSpringCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function setSearchSpringCookieForSession(name, value) {
    document.cookie = name + "=" + (value || "") + "; path=/";
}

function collectionSizeChart(){
  $(".tt-col-item").each(function(index){
  	var objthis = $(this);
  	if(!objthis.hasClass('itemCalled')){
  		var size_content= objthis.find(".tt-option-block .size-move-data" ).html();
  		objthis.find(".size-variant").append(size_content);
  		objthis.addClass("itemCalled");
  	}
  });


  /* Collection Page OnClick of product image */
  if( $('.tt-title a').length > 0 ) {
    $('.tt-title a').each(function(){
      if(!$(this).hasClass('image-title-loaded')){
        $(this).attr('class', 'image-title-loaded');
        $(this).on('click', function(){
            var productId = $(this).parents('div[class^="tt-col-item"]').attr('data-product-id');
            var cookieValue = productId+"##"+collectionName+"##/collections/"+collectionHandle;            
            document.cookie = "prod_col_breadcrub=" + cookieValue + ";" + ";path=/";
        });
      }
    });
  }
  if( $('.img-link').length > 0 ) {
    $('.img-link').each(function(){
      if(!$(this).hasClass('image-loaded')){
        $(this).attr('class', 'image-loaded');
        $(this).on('click', function(){
            var productId = $(this).parents('div[class^="tt-col-item"]').attr('data-product-id');
            var cookieValue = productId+"##"+collectionName+"##/collections/"+collectionHandle;            
            document.cookie = "prod_col_breadcrub=" + cookieValue + ";" + ";path=/";
        });
      }
    });
  }
}

function validateAndCreateCookie(){
  var cookieName1 = "_isuid";
  var cookieName2 = "ssUserId";
  var cookieName3 = "ssSessionIdNamespace";
  
  var cookieValue1 = self.crypto.randomUUID();
  var cookieValue2 = cookieValue1;
  var cookieValue3 = self.crypto.randomUUID();
  
  var cookieExists1 = getSearchSpringCookie(cookieName1);
  var cookieExists2 = getSearchSpringCookie(cookieName2);
  var cookieExists3 = getSearchSpringCookie(cookieName3);
  
  if (cookieExists1 === null) {
    setSearchSpringCookie(cookieName1, cookieValue1, 365);
  }
  if (cookieExists2 === null) {
    setSearchSpringCookie(cookieName2, cookieValue2, 365);
  }
  if (cookieExists3 === null) {
    setSearchSpringCookieForSession(cookieName3, cookieValue3);
  }  
}


function manageSearchSpringCookie(){
  validateAndCreateCookie(); 
}

function getCollectionTouts(){
  var promoHTML = "";
  if(typeof(collectionTouteDesktop) != 'undefined' && collectionTouteDesktop.length > 0){
    collectionTouteDesktop.forEach(promo => {
      if (promo.position === "last") {
        const startTag = promo.link !== "" ? 
          `<a href="${promo.link}" title="${promo.title}" class="desktop-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${promo.position + 1}" data-tile-position="${promo.position}">` : 
          `<div class="desktop-item grid-tile collectionToute tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${promo.position}" data-tile-position="${promo.position}">`;
        const linkContent = (promo.link !== "" && promo.cta_text !== "") ? `<span class="btn btn--secondary" title="${promo.cta_text}">${promo.cta_text}</span>` : "";
        const endTag = promo.link !== "" ? "</a>" : "</div>";
        promoHTML += 
          `${startTag}
            <div class="desktop-item grid-item last-item" style="background-image: url('${promo.image}'); background-color: ${promo.background_color || "#484646"};position: relative;">
              ${promo.video !== '' && promo.mux_playback_id === '' ? promo.video : ""}
              ${promo.video === '' && promo.mux_playback_id !== '' ? `<mux-player playback-id="${promo.mux_playback_id}" autoplay="any" loop></mux-player>` : ""}
              <img class="lazyload" style="width: 100%; visibility: hidden;" src="" alt="">
              ${promo.video !== '' || promo.mux_playback_id !== '' ? `<div class="grid-item__tile-height"></div>` : ''}
              <div class="grid-item__tile-inner ${promo.video !== '' || promo.mux_playback_id !== '' ? " tile-absolute" : ""}" style="color: ${promo.text_color || "#fff"}; position: absolute; top: 0; bottom: 0; left: 0; right: 0;">
                ${promo.title !== "" ? `<span class="title">${promo.title}</span>` : ""}
                ${promo.text !== "" ? `<p>${promo.text}</p>` : ""}
                ${linkContent}
              </div>
            </div>
          ${endTag}`;
      } else {
        const tile_position = parseInt(promo.position);
        const startTag = promo.link !== "" ? 
          `<a href="${promo.link}" title="${promo.title}" class="desktop-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${tile_position + 1}" data-tile-position="${tile_position}">` : 
          `<div class="desktop-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${tile_position + 1}" data-tile-position="${tile_position}">`;   
        const linkContent = (promo.link !== "" && promo.cta_text !== "") ? `<span class="btn btn--secondary" title="${promo.cta_text}">${promo.cta_text}</span>` : "";
        const endTag = promo.link !== "" ? "</a>" : "</div>";
        promoHTML += 
          `${startTag}
          <div class="grid-item" style="background-image: url('${promo.image}'); background-color: ${promo.background_color || "#484646"};">
            ${promo.video !== '' && promo.mux_playback_id === '' ? promo.video : ""}
            ${promo.video === '' && promo.mux_playback_id !== '' ? `<mux-player playback-id="${promo.mux_playback_id}" autoplay="any" loop></mux-player>` : ""}
            ${promo.video !== '' || promo.mux_playback_id !== '' ? `<div class="grid-item__tile-height"></div>` : ''}
            <div class="${promo.video !== '' || promo.mux_playback_id !== '' ? "grid-item__tile-inner tile-absolute" : "grid-item__tile-inner"}" style="color: ${promo.text_color || "#fff"};">
              ${promo.title !== "" ? `<span class="title">${promo.title}</span>` : ""}
              ${promo.text !== "" ? `<p>${promo.text}</p>` : ""}
              ${linkContent}
            </div>
          </div>
        ${endTag}`;
      }
    });
  }

  var promoHTML_Mob = "";
  if(typeof(collectionTouteMobile) != 'undefined' && collectionTouteMobile.length > 0){
    collectionTouteMobile.forEach(promo => {
      if (promo.position === "last") {
        const startTag_mob = promo.link !== "" ? 
          `<a href="${promo.link}" title="${promo.title}" class="mobile-item grid-tile collectionToute tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${promo.position + 1}" data-tile-position="${promo.position}">` : 
          `<div class="mobile-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${promo.position}" data-tile-position="${promo.position}">`;
        const linkContent_mob = (promo.link !== "" && promo.cta_text !== "") ? `<span class="btn btn--secondary" title="${promo.cta_text}">${promo.cta_text}</span>` : "";
        const endTag_mob = promo.link !== "" ? "</a>" : "</div>";
        promoHTML_Mob += 
          `${startTag_mob}
            <div class="grid-item last-item mobile-item" style="background-image: url('${promo.image}'); background-color: ${promo.background_color || "#484646"};position: relative;">
              ${promo.video !== '' && promo.mux_playback_id === '' ? promo.video : ""}
              ${promo.video === '' && promo.mux_playback_id !== '' ? `<mux-player playback-id="${promo.mux_playback_id}" autoplay="any" loop></mux-player>` : ""}
              <img class="lazyload" style="width: 100%; visibility: hidden;" src="" alt="">
              <div class="grid-item__tile-inner ${promo.video !== '' || promo.mux_playback_id !== '' ? " tile-absolute" : ""}" style="color: ${promo.text_color || "#fff"}; position: absolute; top: 0; bottom: 0; left: 0; right: 0;">
                ${promo.title !== "" ? `<span class="title">${promo.title}</span>` : ""}
                ${promo.text !== "" ? `<p>${promo.text}</p>` : ""}
                ${linkContent_mob}
              </div>
            </div>
          ${endTag_mob}`;
      } else {
        const tile_position_mob = parseInt(promo.position);      
        const startTag_mob = promo.link !== "" ? 
          `<a href="${promo.link}" title="${promo.title}" class="mobile-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${tile_position_mob + 1}" data-tile-position="${tile_position_mob}">` : 
          `<div class="mobile-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${tile_position_mob + 1}" data-tile-position="${tile_position_mob}">`;  
        const linkContent_mob = (promo.link !== "" && promo.cta_text !== "") ? `<span class="btn btn--secondary" title="${promo.cta_text}">${promo.cta_text}</span>` : "";
        const endTag_mob = promo.link !== "" ? "</a>" : "</div>";
        promoHTML_Mob +=
          `${startTag_mob}
            <div class="grid-item" style="background-image: url('${promo.image}'); background-color: ${promo.background_color || "#484646"};">                      
              ${promo.video !== '' && promo.mux_playback_id === '' ? promo.video : ""}
              ${promo.video === '' && promo.mux_playback_id !== '' ? `<mux-player playback-id="${promo.mux_playback_id}" autoplay="any" loop></mux-player>` : ""}
              <div class="grid-item__tile-inner ${promo.video !== '' || promo.mux_playback_id !== '' ? "tile-absolute" : ""}" style="color: ${promo.text_color || "#fff"};">
                ${promo.title !== "" ? `<span class="title">${promo.title}</span>` : ""}
                ${promo.text !== "" ? `<p>${promo.text}</p>` : ""}
                ${linkContent_mob}
              </div>
            </div>
          ${endTag_mob}`;
      }
    });
  }
  
  var parser = new DOMParser();
  var promoHTMLParse = parser.parseFromString(promoHTML, 'text/html');
  var promoHTMLParse_Mob = parser.parseFromString(promoHTML_Mob, 'text/html');
  return { promoHTMLParse, promoHTMLParse_Mob };
}

/* ==============  Function for more data in collection Page start   ============== */
function manageCollectionPageData(pageNmbr){
    var currentPage = pageNmbr;
    var arrCollectionData = []; 
    var pageLoad = self.crypto.randomUUID();
    var apiParams = [];
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/search/search.json`; 
    apiParams['urlParms'] = [];
    apiParams['pageRequest'] = pageTemplate;
    apiParams['urlParms']['siteId'] = `${searchSpringId}`; 
    apiParams['urlParms']['page'] = `${pageNmbr}`; 
    apiParams['urlParms']['resultsFormat'] = "json"; 
    apiParams['urlParms']['resultsPerPage'] = `${resultPerPage}`; 
    apiParams['urlParms']['userId'] = `${ssUserIdCookie}`; 
    apiParams['urlParms']['sessionId'] = `${ssSessionIdNamespaceCookie}`;
    apiParams['urlParms']['domain'] = `${currentDomain}`; 
    apiParams['urlParms']['pageLoadId'] = `${pageLoad}`;
  

    /* Check current Window URL & Set Parameter Start */
    const currentURL = `${window.location.origin}${window.location.pathname}${location.search}`;
    const getSearchParams = getFilterParams(currentURL);    
    /* Check cuurent Window URL & Set Parameter End */
    // apiParams['urlParms']["bgfilter.collection_id"]  = currentCollectionId;

    apiParams['page'] = currentPage;

    if( pageNmbr > 1 ){
        apiParams['urlParms']["bgfilter.collection_id"]  = currentCollectionId;
        apiParams['urlParms']['bgfilter.ss_is_published'] = 1;
        apiParams['feturedProductResponse'] = "N";
        var sortingOption = (getSearchParams.sortURL != "" ? getSearchParams.sortURL : "");
        var filterOption = (getSearchParams.filterURL != "" ? getSearchParams.filterURL : "");        
        if( filterOption != "" ){
            var arrFilterSplt = filterOption.split('&');
            for (var i = 0; i < arrFilterSplt.length; i++) {
                var arrFilterValues = arrFilterSplt[i].split("=");                
                if (apiParams['urlParms'][arrFilterValues[0]]) {
                    apiParams['urlParms'][arrFilterValues[0]].push(arrFilterValues[1]);
                } else {
                    apiParams['urlParms'][arrFilterValues[0]] = [arrFilterValues[1]];
                }
            }          
        }
        if( sortingOption != "" ){
            var arrSortingSplt = sortingOption.split('&');
            for( var sptKey in  arrSortingSplt ){
                var sortngStr = arrSortingSplt[sptKey];
                var arrSoringValues = sortngStr.split("=");
                apiParams['urlParms'][arrSoringValues[0]] = arrSoringValues[1];
            }
        }
    }
    else{        
        /* featured pinned product logic Start  */
        if ( featuredProductHandle.length > 0 ){
            hasFeaturedProduct = true;
            apiParams['page'] = currentPage; 
            for (let h = 0; h < featuredProductHandle.length; h++) {
            	if (apiParams['urlParms']["bgfilter.handle"]) {
            		apiParams['urlParms']["bgfilter.handle"].push(featuredProductHandle[h]);
            	} else {
            		apiParams['urlParms']["bgfilter.handle"] = [featuredProductHandle[h]];
            	}
            }

            var filterOptionFeatured = (getSearchParams.filterURL != "" ? getSearchParams.filterURL : "");        
            if( filterOptionFeatured != "" ){
                var arrFilterSpltFeatured = filterOptionFeatured.split('&');
                for (var i = 0; i < arrFilterSpltFeatured.length; i++) {
                    var arrFilterValuesFeatured = arrFilterSpltFeatured[i].split("=");                
                    if (apiParams['urlParms'][arrFilterValuesFeatured[0]]) {
                        apiParams['urlParms'][arrFilterValuesFeatured[0]].push(arrFilterValuesFeatured[1]);
                    } else {
                        apiParams['urlParms'][arrFilterValuesFeatured[0]] = [arrFilterValuesFeatured[1]];
                    }
                }          
            }
          
            apiParams['urlParms']["featureProduct"]  = "Y";
            apiParams["featureProductParams"]  = "Y";
            callSearchSpringAPI(apiParams);
        }
        
        /* Call SeacgSpring API to get collection result */
        delete apiParams['urlParms']["bgfilter.handle"];
		apiParams["featureProductParams"]  = "N";        
        apiParams['urlParms']["bgfilter.collection_id"]  = currentCollectionId;
        apiParams['urlParms']['bgfilter.ss_is_published'] = 1;

        var sortingOption = (getSearchParams.sortURL != "" ? getSearchParams.sortURL : "");
        var filterOption = (getSearchParams.filterURL != "" ? getSearchParams.filterURL : "");        
        if( filterOption != "" ){
            var arrFilterSplt = filterOption.split('&');
            for (var i = 0; i < arrFilterSplt.length; i++) {
                var arrFilterValues = arrFilterSplt[i].split("=");                
                if (apiParams['urlParms'][arrFilterValues[0]]) {
                    apiParams['urlParms'][arrFilterValues[0]].push(arrFilterValues[1]);
                } else {
                    apiParams['urlParms'][arrFilterValues[0]] = [arrFilterValues[1]];
                }
            }          
        }
        if( sortingOption != "" ){
            var arrSortingSplt = sortingOption.split('&');
            for( var sptKey in  arrSortingSplt ){
                var sortngStr = arrSortingSplt[sptKey];
                var arrSoringValues = sortngStr.split("=");
                apiParams['urlParms'][arrSoringValues[0]] = arrSoringValues[1];
            }
        }
    }    
    callSearchSpringAPI(apiParams);
}
/* ==============  Function for more data in collection Page end   ============== */

/* ==============  Function for more search data in search Page start   ============== */
function manageSearchPageData(pageNmbr){
    var currentSearchPage = pageNmbr;    
    var pageLoadSearch = self.crypto.randomUUID();
    var params = new URLSearchParams(document.location.search);
    var searchTerms = params.get("q");
    var resultPerSearchPage = 20;
    var apiParams = [];
    apiParams['pageRequest'] = page_template;
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/search/search.json`; 
    apiParams['urlParms'] = [];
    apiParams['urlParms']['siteId'] = `${searchSpringId}`;
    apiParams['urlParms']['q'] = `${searchTerms}`;
    apiParams['urlParms']['bgfilter.ss_is_published'] = 1;
    apiParams['urlParms']['bgfilter.ss_visibility'] = "search";
    apiParams['urlParms']['page'] = `${currentSearchPage}`; 
    apiParams['urlParms']['resultsFormat'] = "json";     
    apiParams['urlParms']['resultsPerPage'] = `${resultPerSearchPage}`;     
    apiParams['urlParms']['userId'] = `${ssUserIdCookie}`; 
    apiParams['urlParms']['sessionId'] = `${ssSessionIdNamespaceCookie}`; 
    apiParams['urlParms']['domain'] = `${currentDomain}`; 
    apiParams['urlParms']['pageLoadId'] = `${pageLoadSearch}`;
    if(arrFilterRemoveSearch.length > 0){
       apiParams['urlParms']['excludedFacets'] = arrFilterRemoveSearch;
    }

    /* Check current Window URL & Set Parameter Start */
    const currentURLSearch = `${window.location.origin}${window.location.pathname}${location.search}`;
    const getSearchParamsSearch = getFilterParams(currentURLSearch);
  
    var sortingOptionSearch = (getSearchParamsSearch.sortURL != "" ? getSearchParamsSearch.sortURL : "");
    var filterOptionSearch = (getSearchParamsSearch.filterURL != "" ? getSearchParamsSearch.filterURL : "");
    
    if( filterOptionSearch != "" ){
        var arrFilterSplt = filterOptionSearch.split('&');
        for (var i = 0; i < arrFilterSplt.length; i++) {
            var arrFilterValues = arrFilterSplt[i].split("=");                
            if (apiParams['urlParms'][arrFilterValues[0]]) {
                apiParams['urlParms'][arrFilterValues[0]].push(arrFilterValues[1]);
            } else {
                apiParams['urlParms'][arrFilterValues[0]] = [arrFilterValues[1]];
            }
        }                
    }
    if( sortingOptionSearch != "" ){
        var arrSortingSpltSearch = sortingOptionSearch.split('&');
        for( var sptKey in  arrSortingSpltSearch ){
            var sortngStr = arrSortingSpltSearch[sptKey];
            var arrSoringValues = sortngStr.split("=");
            apiParams['urlParms'][arrSoringValues[0]] = arrSoringValues[1];
        }
    }
    callSearchSpringAPI(apiParams);
}
/* ==============  Function for more search data in search Page end   ============== */

/* ==============  Function for validate and create cookie for Search Spring end   ============== */

/* ==============  Function for get params for Search Spring start   ============== */
function getFilterParams(url) {
    const queryString = url.split('?')[1];
    const filterParams = [];
    const sortParams = [];
    const featuredParams = [];
    if (queryString) {
        const params = queryString.split('&');
        params.forEach(param => {
            const [key, value] = param.split('=').map(decodeURIComponent);            
            if (key.startsWith('filter.')) {
                filterParams.push(`${key}=${value}`);                                
            }
            if (key.startsWith('sort.')) {
                sortParams.push(`${key}=${value}`);                                
            }
            if (key.startsWith('featured')) {
                featuredParams.push(`${key}=${value}`);                                
            }           
        });
    }      
    const filterURL = filterParams.join('&');
    const sortURL = sortParams.join('&');
    const featuredURL = featuredParams.join('&');    
    return { filterURL, sortURL, featuredURL};
}
/* ==============  Function for get params for Search Spring end   ============== */

/* ==============  Function for handle filter and sorting start   ============== */
function handleFilterClick(event) {
    var target = event.target;    
    var inputTag = ``;
    if(typeof(target) != "undefined"){
      inputTag = event.querySelector('input');
      const filterName = 'filter.'+inputTag.getAttribute('data-filterField');
      let filterValue = inputTag.getAttribute('data-value');
      filterValue = filterValue.split(',').map(value => value.trim());
      
      const queryParams = new URLSearchParams(window.location.search);
      const currentFilterValues = queryParams.getAll(filterName); 

      let updatedFilterValues;

      if (filterValue.every(value => currentFilterValues.includes(value))) {            
          updatedFilterValues = currentFilterValues.filter(value => !filterValue.includes(value));
      } else {           
          updatedFilterValues = [...currentFilterValues, ...filterValue.filter(value => !currentFilterValues.includes(value))];
      }    
      updateURLParams({ [filterName]: updatedFilterValues });
    }else{
      var parentDiv = event.parentElement;      
      inputTag = event;      
      const filterNamelow = 'filter.'+inputTag.getAttribute('data-filterField')+'.low';
      const filterNamehigh = 'filter.'+inputTag.getAttribute('data-filterField')+'.high';    
      var minValueRangeVal = parentDiv.querySelector('.range-min').value;
      var maxValueRangeVal = parentDiv.querySelector('.range-max').value; 

      var currencyConvertRateFilter = inputTag.getAttribute('data-currencyrate');

      var newMinValueRangeVal = Math.ceil((parseInt(minValueRangeVal) / parseInt(currencyConvertRateFilter)));
      var newMaxValueRangeVal =  Math.ceil((parseInt(maxValueRangeVal) / parseInt(currencyConvertRateFilter)));
      updateURLParams({ [filterNamelow]: newMinValueRangeVal, [filterNamehigh]: newMaxValueRangeVal });            
    }
}

function handleSortingChange(eventSort) {    
    const sort = eventSort.value;
    updateURLParams({}, sort);
}

function updateURLParams(filters, sorting) {
    $(".filtres-js li a").css('pointer-events','none');
    const queryParams = new URLSearchParams(window.location.search);  
    for (const key in filters) {
        if (filters.hasOwnProperty(key)) {
            const values = filters[key];
            if (Array.isArray(values)) {
                queryParams.delete(key);
                values.forEach(val => {
                    queryParams.append(key, val);
                });
            } else {
                queryParams.set(key, values); 
            }
        }
    }
    if (sorting) {
        queryParams.forEach((value, key) => {
            if (key.startsWith('sort.')) {
                queryParams.delete(key);
            }
        });
        const [field, order] = sorting.split('=');
        queryParams.set(`sort.${field}`, order);    
    }

    let queryParamsNew = '';
    let index = 0;
    for (const [key, value] of queryParams.entries()) {      
      if(index == 0){
        queryParamsNew+= key+"="+value;  
      }else{
        queryParamsNew+= "&"+key+"="+value;
      }      
      index++;
    }
  
    // const newURL = window.location.pathname + '?' + queryParams.toString();
    const newURL = window.location.pathname + '?' + queryParamsNew;    
    
    window.history.pushState({ path: newURL }, '', newURL);

    if($(".tt-btn-col-close a").is(':visible')){
      $(".tt-btn-col-close a").click();
    }
    
    if(page_template == 'collection'){
      manageCollectionPageData(1);  
    }
    if(page_template == 'page.search-result-searchspring'){
      manageSearchPageData(1);
    }
}
function clearAllParams(){
  var queryParamsClearAll = new URLSearchParams(window.location.search); 
  var keysToDelete = [];
  queryParamsClearAll.forEach((value, key) => {
    if ((page_template === 'collection' && key.includes('filter.')) || (page_template === 'page.search-result-searchspring' && key !== 'q' && !key.includes('sort.'))) {
      keysToDelete.push(key);
    }
  });
  keysToDelete.forEach(key => queryParamsClearAll.delete(key));
  
  const newURLParamsClear = window.location.pathname + '?' + queryParamsClearAll.toString();
  window.history.pushState({ path: newURLParamsClear }, '', newURLParamsClear);
  if(page_template == 'collection'){
    manageCollectionPageData(1);  
  }
  if(page_template == 'page.search-result-searchspring'){
    manageSearchPageData(1);
  }
}
/* ==============  Function for handle filter and sorting end   ============== */


function commonFuncForFilterCollapse(){
  var item = $('#tt-pageContent').find('.tt-collapse');
  itemTitle = item.find('.tt-collapse-title'),
  itemContent = item.find('.tt-collapse-content');
  
  item.each(function() {
      if ($(this).hasClass('open')) {
        $(this).find(itemContent).slideDown();
      } else {
        $(this).find(itemContent).slideUp();
      }
  });
  itemTitle.on('click', function(e) {
      e.preventDefault();
      var speed = 300;
      var thisParent = $(this).parent(),
          nextLevel = $(this).next('.tt-collapse-content');
      if (thisParent.hasClass('open')) {
        thisParent.removeClass('open');
        nextLevel.slideUp(speed);
      } else {
        thisParent.addClass('open');
        nextLevel.slideDown(speed);
      }
  });

  /* OnClick of cross button sidebar close */
  $('#tt-pageContent').find('.leftColumn.aside').find('.tt-btn-col-close').on('click', function(e) {
  	e.preventDefault();
  	$('#tt-pageContent').find('.leftColumn.aside').removeClass('column-open');
  	var top = parseInt($body.css("top").replace("px", ""), 10) * -1;
  	$body.removeAttr("style").removeClass("no-scroll").scrollTop(top);
  
  	$html.removeAttr("style").scrollTop(top);
  	$(".modal-filter").unbind().remove();
  });
  /* Price Slider Filter JS - End */   
}


/* ==============  Function for handle Filter data after get responce of SearchSpringAPI Start   ============== */
function searchSpringFilterHandle(arrFilter){
  if($(".new-filter").length > 0 ){
    $(".new-filter").remove();
  }
  if($(".clear-all-button").length > 0){
    $(".clear-all-button").remove();
  }

  /* Add clear all button - start */
  var clearAllButton = "";
  var filterTitle = "";
  const currentURL = `${window.location.origin}${window.location.pathname}${location.search}`;
  const getSearchParams = getFilterParams(currentURL);      
  if($(".clear-all-button").length <= 0){
    clearAllButton += `
      <div class="filter-collapse-clear clear-all-button tt-collapse open ${getSearchParams.filterURL != "" ? "" : "hide" }">
        <h3 class="tt-collapse-title">${"SHOPPING BY:"}</h3>
        <div class="tt-collapse-content filtres-remove-js">          
          <a href="javascript:void(0);" onclick="clearAllParams();" class="btn-link-02 filtres-remove-js clear_all ajax-clik">${"Clear All"}</a>
        </div>
      </div>
    `;
  }

  if($(".filter-title").length <= 0){
    filterTitle+= `<div class="filter-title mob-bred-hide">FILTERs</div><div class="tt-btn-col-close">
      <div class="filter-title mob-show">FILTERs</div>
      <a href="javascript:;">CLOSE</a>
    </div>`;        
  }
  
  if($(".filter-column .sidebar-menu").length > 0){
    $(filterTitle).insertBefore(".filter-column .sidebar-menu"); 
    $(clearAllButton).insertBefore(".filter-column .sidebar-menu");  
  }else{
    $(".filter-column").append(filterTitle);
    $(".filter-column").append(clearAllButton);
  }
  /* Add clear all button - end */

  if( $(".filter-column").length > 0 ){
    var newFilterHTML = "";       
    for(var f = 0; f < arrFilter.length; f++) {
      var newFilterValueHtml = "";
      var facetFilterType = arrFilter[f].type;
      var facetFilterField = arrFilter[f].field;
      var organizedFilterValues = {};
      if(arrFilter[f].values.length > 1){
        arrFilter[f].values.forEach(function(filterOptionValue) {
            var lowercaseOptionValue = filterOptionValue.value.toLowerCase();
            var length = filterOptionValue.count;
        
            if (!organizedFilterValues[lowercaseOptionValue]) {
                organizedFilterValues[lowercaseOptionValue] = {
                    "value": {},
                    "status": filterOptionValue.active
                };
            }
            organizedFilterValues[lowercaseOptionValue]["value"][filterOptionValue.label] = length;
        });
      }

      
      for (var key in organizedFilterValues) {
        var filterValue = Object.keys(organizedFilterValues[key].value).join(',');   
        var hasTagsValuePrefix = false;
        if(searchSpringUniqueTagArrLogic == "true"){
          hasTagsValuePrefix = searchSpringUniqueTagArr.includes(arrFilter[f].field.toLowerCase() + "-" + key);  
        }else{
          hasTagsValuePrefix = true;
        }
        if(facetFilterType == 'palette' && hasTagsValuePrefix){
           newFilterValueHtml += `
            <li style="${organizedFilterValues[key].status ? 'border: 1px solid #000000' : ''}">
              <a href="javascript:void(0);" title="${key}" onclick="handleFilterClick(this);" style="background-image:url('https://www.jamesperse.com/cdn/shop/files/color-${key.replace(/[/ ]/g, "-")}.png');height: 100%;">
                <span style="cursor:pointer;">
                  <input type="checkbox" style="display:none !important;" data-filterField="${facetFilterField}" ${organizedFilterValues[key].status ? 'checked="checked"' : ''} value="${key}" data-value="${filterValue}" title="${filterValue}" aria-label="${filterValue}" class="input-checkbox ajax-clik ${organizedFilterValues[key].status ? ' active' : ''}" />                     
                </span>
              </a>
            </li>
          `;
        }else if(facetFilterType == 'grid' && hasTagsValuePrefix){
           newFilterValueHtml += `
            <li style="${organizedFilterValues[key].status ? 'border: 1px solid #000000' : ''}">
              <a href="javascript:void(0);" onclick="handleFilterClick(this);">
                <span style="cursor:pointer;">
                  <input type="checkbox" style="display:none !important;" data-filterField="${facetFilterField}" ${organizedFilterValues[key].status ? 'checked="checked"' : ''} value="${key}" data-value="${filterValue}" title="${filterValue}" aria-label="${filterValue}" class="input-checkbox ajax-clik ${organizedFilterValues[key].status ? ' active' : ''}" />                     
                  ${Object.keys(organizedFilterValues[key].value).length > 1 ? `${key}` : `${Object.keys(organizedFilterValues[key].value)}`}
                </span>
              </a>
            </li>
          `;            
        }else{
          if(hasTagsValuePrefix){
            var productCnt = 0;
            if(collectionPageCountflag){
              var keyValue = Object.keys(organizedFilterValues[key].value);
              if(Object.keys(organizedFilterValues[key].value).length > 1){
                for (var prdCnt = 0; prdCnt < keyValue.length; prdCnt++) {
                    productCnt += parseFloat(organizedFilterValues[key].value[keyValue[prdCnt]]);
                }
              }else{
                var productCnt = organizedFilterValues[key].value[keyValue];
              }
            }
            newFilterValueHtml += `
              <li>
                <a href="javascript:void(0);" onclick="handleFilterClick(this);">
                  <span class="checkbox-container">
                      <input type="checkbox" data-filterField="${facetFilterField}" ${organizedFilterValues[key].status ? 'checked="checked"' : ''} value='${key}' data-value="${filterValue}" title="${filterValue}" aria-label="${filterValue}" class="input-checkbox ajax-click ${organizedFilterValues[key].status ? ' active' : ''}" />
                      <span class="value-container">
                          <span ${facetFilterField == "tags_fabric" ? `style="text-transform: uppercase;"` : `style="text-transform: capitalize;"`}>${Object.keys(organizedFilterValues[key].value).length > 1 ? key : Object.keys(organizedFilterValues[key].value)}</span>
                          ${collectionPageCountflag != false ? `<span class="count"><b>(${productCnt})</b></span>` : ""}                          
                      </span>
                  </span>
                </a>
              </li>
            `;
          }
        }
      }

      /* Filter main structure */
      var hasTagsPrefix = false;
      var hasTagsPrefixValueFlag = false;
      if(searchSpringUniqueTagArrLogic == "true"){
        hasTagsPrefix = searchSpringUniqueTagArr.some(element => element.startsWith(arrFilter[f].field));
        if(newFilterValueHtml){
          hasTagsPrefixValueFlag = true;
        }
      }else{
        hasTagsPrefix = true;
        hasTagsPrefixValueFlag = true;
      }

      if(arrFilter[f].type == 'palette' && hasTagsPrefix && hasTagsPrefixValueFlag){
          newFilterHTML += `<div class="tt-collapse ${(arrFilter[f].collapse === 0 || arrFilter[f].facet_active > 0) ? "open" : ""} new-filter">
            <h3 class="tt-collapse-title">${arrFilter[f].label.toUpperCase()}</h3>
            <div class="tt-collapse-content filter-type-${arrFilter[f].type}">              
              <ul class="tt-list-row filtres-js">
                ${newFilterValueHtml}
              </ul>
            </div>
          </div>`;          
      }else if (arrFilter[f].type == 'grid' && hasTagsPrefix && hasTagsPrefixValueFlag){
          newFilterHTML += `<div class="tt-collapse ${(arrFilter[f].collapse === 0 || arrFilter[f].facet_active > 0) ? "open" : ""} new-filter">
              <h3 class="tt-collapse-title">${arrFilter[f].label.toUpperCase()}</h3>
              <div class="tt-collapse-content filter-type-${arrFilter[f].type}">
                <ul class="tt-list-row filtres-js">
                  ${newFilterValueHtml}
                </ul>
              </div>
            </div>`;
      }else if (arrFilter[f].type == 'slider'){
        newFilterHTML += `<div class="tt-collapse ${(arrFilter[f].collapse === 0 || arrFilter[f].facet_active > 0) ? "open" : ""} new-filter">
            <h3 class="tt-collapse-title">${arrFilter[f].label.toUpperCase()}</h3>
            <div class="tt-collapse-content filter-type-${arrFilter[f].type}">
              <div class="wrapper">                  
                <div class="price-input">
                  <div class="field min">        
                    <input type="number" id="inputMin" data-filterField="${arrFilter[f].field}" class="input-min" value=${arrFilter[f].range[0]} data-value=${arrFilter[f].range[0]}>
                  </div>
                  <div class="separator">-</div>
                  <div class="field max">
                    <input type="number" id="inputMax" data-filterField="${arrFilter[f].field}" class="input-max" value=${arrFilter[f].range[1]} data-value=${arrFilter[f].range[1]}>
                  </div>
                </div>
                <div class="slider">
                  <div class="progress"></div>
                </div>
                <div class="range-input">
                  <input type="range" id="rangeMin" data-currencyRate="" data-filterField="${arrFilter[f].field}" class="range-min" min=${arrFilter[f].range[0]} max=${arrFilter[f].range[1]} data-value=${arrFilter[f].range[0]} value=${arrFilter[f].range[0]} step="1">
                  <input type="range" id="rangeMax" data-currencyRate="" data-filterField="${arrFilter[f].field}" class="range-max" min=${arrFilter[f].range[0]} max=${arrFilter[f].range[1]} data-value=${arrFilter[f].range[1]} value=${arrFilter[f].range[1]} step="1">
                </div>
              </div>
            </div>
          </div>`;          
      }else{
        if(hasTagsPrefix && hasTagsPrefixValueFlag){            
          newFilterHTML += `
            <div class="tt-collapse ${(arrFilter[f].collapse === 0 || arrFilter[f].facet_active > 0) ? "open" : ""} new-filter">
              <h3 class="tt-collapse-title">${arrFilter[f].label.toUpperCase()}</h3>
              <div class="tt-collapse-content filter-type-${arrFilter[f].type}">
                <ul class="tt-list-row filtres-js">
                  ${newFilterValueHtml}
                </ul>
                ${(arrFilter[f].field == 'tags_size' && typeof(collectionFitguideValue) != 'undefined') ? `<a data-toggle="modal" data-target="#modalProductInfo" href="#" class="fit-link">Fit Guide</a>` : '' }
              </div>
            </div>        
          `;
        }
      }
    }
    if($(".filter-column .sidebar-menu").length > 0){
      $(newFilterHTML).insertBefore(".filter-column .sidebar-menu");  
    }else{
      $(".filter-column").append(newFilterHTML);
    }
    
    /* Size Chart popup - start */
    var sizechart = ``;
    if(typeof(collectionFitguideValue) != 'undefined'){
      if(collectionFitguideValue == 'Men Fit Guide popup'){
        sizechart = `<div class="wrapper clearfix sizechart-popup">
    <h1 class="underline">Size Chart</h1>
    <p>These charts are general size guidelines. Sizes refer to body measure and not garment dimensions. Look for further sizing information in the product description area. If you are unsure what size to get or if you are in-between sizes, we recommend you order the larger size.</p>
    <div class="table-head">Men's Body Measurements</div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart cms-page-table measurments" summary="Column one has the product type, other columns show measurements.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">Sizes</th>
                <th scope="col" style="text-align: left;">0</th>
                <th scope="col" style="text-align: left;">1</th>
                <th scope="col" style="text-align: left;">2</th>
                <th scope="col" style="text-align: left;">3</th>
                <th scope="col" style="text-align: left;">4</th>
                <th scope="col" style="text-align: left;">5</th>
            </tr>
            <tr>
                <th> 
                </th>
                <th scope="col">XS
                </th>
                <th scope="col">S
                </th>
                <th scope="col">M
                </th>
                <th scope="col">L
                </th>
                <th scope="col">XL
                </th>
                <th scope="col">XXL
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">Chest</th>
                <td>35 in<br>88.9 cm</td>
                <td>37 in<br>94 cm</td>
                <td>39 in<br>99.1 cm</td>
                <td>41 in<br>104.1 cm</td>
                <td>43 in<br>109.2 cm</td>
                <td>45 in<br>114.3 cm</td>
            </tr>
            <tr>
                <th scope="row">True Waist</th>
                <td>28 in<br>71.1 cm</td>
                <td>30 in<br>76.2 cm</td>
                <td>32 in<br>81.3 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>37 in<br>94 cm</td>
                <td>39 in<br>99.1 cm</td>
            </tr>
            <tr>
                <th scope="row">Low Hip</th>
                <td>34 in<br>86.4 cm</td>
                <td>36 in<br>91.4 cm</td>
                <td>38 in<br>96.5 cm</td>
                <td>40 in<br>101.6 cm</td>
                <td>42 in<br>106.7 cm</td>
                <td>44 in<br>111.8 cm</td>
            </tr>
            <tr>
                <th scope="row">Across Shoulder</th>
                <td>17 in<br>43.2 cm</td>
                <td>17 <sup>1</sup>⁄<sub>2</sub> in<br>44.5 cm</td>
                <td>18 in<br>45.7 cm</td>
                <td>18 <sup>1</sup>⁄<sub>2</sub> in<br>47 cm</td>
                <td>19 in<br>48.3 cm</td>
                <td>19 <sup>1</sup>⁄<sub>2</sub> in<br>50.2 cm</td>
            </tr>
            <tr>
                <th scope="row">Arm Length</th>
                <td>32 <sup>1</sup>⁄<sub>2</sub> in<br>82.6 cm</td>
                <td>33 <sup>1</sup>⁄<sub>4</sub> in<br>84.5 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 <sup>3</sup>⁄<sub>4</sub> in<br>88.3 cm</td>
                <td>35 <sup>5</sup>⁄<sub>8</sub> in<br>90.5 cm</td>
                <td>36 <sup>1</sup>⁄<sub>2</sub> in<br>92.7 cm</td>
            </tr>
            <tr class="last">
                <th scope="row">Inseam</th>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
            </tr>
        </tbody>
    </table>
    </div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart measurments" summary="Column one has the product type, other columns show measurements.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">Sizes</th>
                <th scope="col" style="text-align: left;">28</th>
                <th scope="col" style="text-align: left;">30</th>
                <th scope="col" style="text-align: left;">32</th>
                <th scope="col" style="text-align: left;">33</th>
                <th scope="col" style="text-align: left;">34</th>
                <th scope="col" style="text-align: left;">36</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">True Waist</th>
                <td>28 in<br>71.1 cm</td>
                <td>30 in<br>76.2 cm</td>
                <td>32 in<br>81.3 cm</td>
                <td>33 in<br>83.8 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>36 in<br>91.4 cm</td>
            </tr>
            <tr class="last">
                <th scope="row">Low Hip</th>
                <td>34 in<br>86.4 cm</td>
                <td>36 in<br>91.4 cm</td>
                <td>38 in<br>96.5 cm</td>
                <td>39 in<br>99.1 cm</td>
                <td>40 in<br>101.6 cm</td>
                <td>42 in<br>106.7 cm</td>
            </tr>
        </tbody>
    </table>
    </div>
    <h2 class="underline">How to Measure</h2>
    <h3>Chest</h3>
    <p>Measure under arms around the fullest part of the chest. Be sure to keep tape level across back and comfortably loose.</p>
    <h3>True Waist</h3>
    <p>Measure around the narrowest part of your torso. This is usually right below your belly button. Be sure to keep tape level and comfortably loose.</p>
    <h3>Low Hip</h3>
    <p>Standing with your heels together measure around the fullest part of your hips. Your lower hip is about 8 inches from your waist.</p>
    <h3>Men's Arm Length</h3>
    <p>With your arm bent 90 degrees at the elbow measure from the center of the back of your neck to your wrist.</p>
    <br>
    <div class="table-head">Sizing Conversions</div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart cms-page-table measurments" summary="Column one has system of measurement, other columns show size values.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">Sizes</th>
                <th scope="col" style="text-align: left;">XS</th>
                <th scope="col" style="text-align: left;">S</th>
                <th scope="col" style="text-align: left;">M</th>
                <th scope="col" style="text-align: left;">L</th>
                <th scope="col" style="text-align: left;">XL</th>
                <th scope="col" style="text-align: left;">XXL</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">James Perse</th>
                <td>0</td>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
            </tr>
            <tr>
                <th scope="row">UK/US</th>
                <td>XS</td>
                <td>S</td>
                <td>M</td>
                <td>L</td>
                <td>XL</td>
                <td>XXL</td>
            </tr>
            <tr>
                <th scope="row">EU/FR</th>
                <td>40</td>
                <td>42</td>
                <td>44</td>
                <td>46</td>
                <td>48</td>
                <td>50</td>
            </tr>
            <tr>
                <th scope="row">ITA</th>
                <td>44</td>
                <td>46</td>
                <td>48</td>
                <td>50</td>
                <td>52</td>
                <td>54</td>
            </tr>
            <tr>
                <th scope="row">Waist</th>
                <td>28 in<br>71.1 cm</td>
                <td>30 in<br>76.2 cm</td>
                <td>32 in<br>81.3 cm</td>
                <td>33 in<br>83.8 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>36 in<br>91.4 cm</td>
            </tr>
            <tr class="last">
                <th scope="row">Chest</th>
                <td>35 in<br>88.9 cm</td>
                <td>37 in<br>94.0 cm</td>
                <td>39 in<br>99.1 cm</td>
                <td>41 in<br>104.1 cm</td>
                <td>43 in<br>109.2 cm</td>
                <td>45 in<br>114.3 cm</td>
            </tr>
        </tbody>
    </table>
    </div>
</div>`;
      }else if(collectionFitguideValue == 'Women Fit Guide popup'){
        sizechart = `<div class="wrapper clearfix sizechart-popup">
    <h1 class="underline">Size Chart</h1>
    <p>These charts are general size guidelines. Sizes refer to body measure and not garment dimensions. Look for further sizing information in the product description area. If you are unsure what size to get or if you are in-between sizes, we recommend you order the larger size.</p>
    <div class="table-head">Women's Body Measurements</div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart cms-page-table measurments" summary="Column one has the product type, other columns show measurements.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">Sizes</th>
                <th scope="col" style="text-align: left;">0</th>
                <th scope="col" style="text-align: left;">1</th>
                <th scope="col" style="text-align: left;">2</th>
                <th scope="col" style="text-align: left;">3</th>
                <th scope="col" style="text-align: left;">4</th>
            </tr>
            <tr>
                <th> </th>
                <th scope="col">XS</th>
                <th scope="col">S</th>
                <th scope="col">M</th>
                <th scope="col">L</th>
                <th scope="col">XL</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">Bust</th>
                <td>31 in<br>78.7 cm</td>
                <td>33 in<br>83.8 cm</td>
                <td>35 in<br>88.9 cm</td>
                <td>37 in<br>93.9 cm</td>
                <td>39 in<br>99.1 cm</td>
            </tr>
            <tr>
                <th scope="row">True Waist</th>
                <td>23 <sup>1</sup>⁄<sub>2</sub> in<br>59.7 cm</td>
                <td>25 <sup>1</sup>⁄<sub>2</sub> in<br>64.8 cm</td>
                <td>27 <sup>1</sup>⁄<sub>2</sub> in<br>69.9 cm</td>
                <td>29 <sup>1</sup>⁄<sub>2</sub> in<br>74.9 cm</td>
                <td>31 <sup>1</sup>⁄<sub>2</sub> in<br>80 cm</td>
            </tr>
            <tr>
                <th scope="row">Low Hip</th>
                <td>34 in<br>86.4 cm</td>
                <td>36 in<br>91.4 cm</td>
                <td>38 in<br>96.5 cm</td>
                <td>40 in<br>101.6 cm</td>
                <td>42 in<br>106.7 cm</td>
            </tr>
            <tr>
                <th scope="row">Across Shoulder</th>
                <td>14 in<br>35.6 cm</td>
                <td>14 <sup>1</sup>⁄<sub>2</sub> in<br>36.8 cm</td>
                <td>15 in<br>38.1 cm</td>
                <td>15 <sup>1</sup>⁄<sub>2</sub> in<br>39.4 cm</td>
                <td>16 in<br>40.6 cm</td>
            </tr>
            <tr>
                <th scope="row">Arm Length</th>
                <td>23 in<br>58.4 cm</td>
                <td>23 <sup>1</sup>⁄<sub>2</sub> in<br>59.7 cm</td>
                <td>24 in<br>61 cm</td>
                <td>24 <sup>1</sup>⁄<sub>2</sub> in<br>62.2 cm</td>
                <td>25 in<br>63.5 cm</td>
            </tr>
            <tr class="last">
                <th scope="row">Inseam</th>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 in<br>86.4 cm</td>
            </tr>
        </tbody>
    </table>
    </div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart cms-page-table measurments" summary="Column one has the product type, other columns show measurements.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">SIZES</th>
                <th scope="col" style="text-align: left;">24</th>
                <th scope="col" style="text-align: left;">25</th>
                <th scope="col" style="text-align: left;">26</th>
                <th scope="col" style="text-align: left;">27</th>
                <th scope="col" style="text-align: left;">28</th>
                <th scope="col" style="text-align: left;">29</th>
                <th scope="col" style="text-align: left;">30</th>
                <th scope="col" style="text-align: left;">31</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">True Waist</th>
                <td>23 <sup>1</sup>⁄<sub>2</sub> in<br>59.7 cm</td>
                <td>24 <sup>1</sup>⁄<sub>2</sub> in<br>62.2 cm</td>
                <td>25 <sup>1</sup>⁄<sub>2</sub> in<br>64.8 cm</td>
                <td>26 <sup>1</sup>⁄<sub>2</sub> in<br>67.3 cm</td>
                <td>27 <sup>1</sup>⁄<sub>2</sub> in<br>69.9 cm</td>
                <td>28 <sup>1</sup>⁄<sub>2</sub> in<br>72.4 cm</td>
                <td>29 <sup>1</sup>⁄<sub>2</sub> in<br>74.9 cm</td>
                <td>30 <sup>1</sup>⁄<sub>2</sub> in<br>77.5 cm</td>
            </tr>
            <tr class="last">
                <th scope="row">Low Hip</th>
                <td>34 in<br>86.4 cm</td>
                <td>35 in<br>88.9 cm</td>
                <td>36 in<br>91.4 cm</td>
                <td>37 in<br>94 cm</td>
                <td>38 in<br>96.5 cm</td>
                <td>39 in<br>99.1 cm</td>
                <td>40 in<br>101.6 cm</td>
                <td>41 in<br>104.1 cm</td>
            </tr>
        </tbody>
    </table>
    </div>
    <h2 class="underline size-subtitle">How to Measure</h2>
    <h3>Bust</h3>
    <p>Measure under arms around the fullest part of the chest. Be sure to keep tape level across back and comfortably loose.</p>
    <h3>True Waist</h3>
    <p>Measure around the narrowest part of your torso. This is usually right below your belly button. Be sure to keep tape level and comfortably loose.</p>
    <h3>Low Hip</h3>
    <p>Standing with your heels together measure around the fullest part of your hips. Your lower hip is about 8 inches from your waist.</p>
    <h3>Women's Arm Length</h3>
    <p>Measure from your shoulder to the bottom of your wrist. Be sure to keep your arm straight at your side.</p>
    <br>
    <div class="table-head">Sizing Conversions</div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart cms-page-table measurments" summary="Column one has system of measurement, other columns show size values.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">Sizes</th>
                <th scope="col" style="text-align: left;">XS</th>
                <th scope="col" style="text-align: left;">S</th>
                <th scope="col" style="text-align: left;">M</th>
                <th scope="col" style="text-align: left;">L</th>
                <th scope="col" style="text-align: left;">XL</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">James Perse</th>
                <td>0</td>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
            </tr>
            <tr>
                <th scope="row">UK</th>
                <td>6</td>
                <td>8</td>
                <td>10</td>
                <td>12</td>
                <td>14</td>
            </tr>
            <tr>
                <th scope="row">US</th>
                <td>2</td>
                <td>4</td>
                <td>6</td>
                <td>8</td>
                <td>10</td>
            </tr>
            <tr>
                <th scope="row">EU/FR</th>
                <td>34</td>
                <td>36</td>
                <td>38</td>
                <td>40</td>
                <td>42</td>
            </tr>
            <tr>
                <th scope="row">ITA</th>
                <td>38</td>
                <td>40</td>
                <td>42</td>
                <td>44</td>
                <td>46</td>
            </tr>
            <tr>
                <th scope="row">Waist</th>
                <td>23 <sup>1</sup>⁄<sub>2</sub> in<br>59.7cm</td>
                <td>25 <sup>1</sup>⁄<sub>2</sub> in<br>64.8cm</td>
                <td>27 <sup>1</sup>⁄<sub>2</sub> in<br>69.9cm</td>
                <td>29 <sup>1</sup>⁄<sub>2</sub> in<br>74.9cm</td>
                <td>31 <sup>1</sup>⁄<sub>2</sub> in<br>80.0cm</td>
            </tr>
            <tr class="last">
                <th scope="row">Bust</th>
                <td>31 in<br>78.7cm</td>
                <td>33 in<br>83.8cm</td>
                <td>35 in<br>88.9 cm</td>
                <td>37 in<br>94.0 cm</td>
                <td>39 in<br>99.1 cm</td>
            </tr>
        </tbody>
    </table>
    </div>
</div>`;
      }else if(collectionFitguideValue == 'Footwear Fit Guide popup'){
        sizechart = `<div class="wrapper clearfix sizechart-popup">
    <h1 class="underline">SIZE CHARTS</h1>
    <p>These charts are general size guidelines. Sizes refer to body measure and not garment dimensions. Look for further sizing information in the product description area. If you are unsure what size to get or if you are in-between sizes, we recommend you order the larger size.</p>
    <h2 class="underline">MEN'S SHOES</h2>
    <div class="mobile-tbl-scroll">
    <table class="sizechart measurments">
        <thead>
            <tr>
                <th style="text-align: left;"><strong>INTERNATIONAL EQUIVALENTS</strong></th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">US</th>
                <td style="text-align: left;">7</td>
                <td style="text-align: left;">8</td>
                <td style="text-align: left;">9</td>
                <td style="text-align: left;">10</td>
                <td style="text-align: left;">11</td>
                <td style="text-align: left;">12</td>
            </tr>
            <tr class="last">
                <th scope="row">EUROPEAN</th>
                <td style="text-align: left;">40</td>
                <td style="text-align: left;">41</td>
                <td style="text-align: left;">42</td>
                <td style="text-align: left;">43</td>
                <td style="text-align: left;">44</td>
                <td style="text-align: left;">45</td>
            </tr>
        </tbody>
    </table>
    </div>
    <h2 class="underline">WOMEN'S SHOES</h2>
    <div class="mobile-tbl-scroll">
    <table class="sizechart measurments">
        <thead>
            <tr>
                <th style="text-align: left;"><strong>INTERNATIONAL EQUIVALENTS</strong></th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">US</th>
                <td style="text-align: left;">6</td>
                <td style="text-align: left;">7</td>
                <td style="text-align: left;">8</td>
                <td style="text-align: left;">9</td>
                <td style="text-align: left;">10</td>
            </tr>
            <tr class="last">
                <th scope="row">EUROPEAN</th>
                <td style="text-align: left;">36</td>
                <td style="text-align: left;">37</td>
                <td style="text-align: left;">38</td>
                <td style="text-align: left;">39</td>
                <td style="text-align: left;">40</td>
            </tr>
        </tbody>
    </table>
    </div>
</div>`;
      }else if(collectionFitguideValue == 'Universal Fit Guide popup'){
        sizechart = `<div class="wrapper clearfix sizechart-popup">
    <h1 class="underline">Size Chart</h1>
    <p>These charts are general size guidelines. Sizes refer to body measure and not garment dimensions. Look for further sizing information in the product description area. If you are unsure what size to get or if you are in-between sizes, we recommend you order the larger size.</p>
    <div class="table-head">Men's Body Measurements</div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart cms-page-table measurments" summary="Column one has the product type, other columns show measurements.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">Sizes</th>
                <th scope="col" style="text-align: left;">0</th>
                <th scope="col" style="text-align: left;">1</th>
                <th scope="col" style="text-align: left;">2</th>
                <th scope="col" style="text-align: left;">3</th>
                <th scope="col" style="text-align: left;">4</th>
                <th scope="col" style="text-align: left;">5</th>
            </tr>
            <tr>
                <th> 
                </th>
                <th scope="col">XS
                </th>
                <th scope="col">S
                </th>
                <th scope="col">M
                </th>
                <th scope="col">L
                </th>
                <th scope="col">XL
                </th>
                <th scope="col">XXL
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">Chest</th>
                <td>35 in</td>
                <td>37 in</td>
                <td>39 in</td>
                <td>41 in</td>
                <td>43 in</td>
                <td>45 in</td>
            </tr>
            <tr>
                <th scope="row">True Waist</th>
                <td>28 in</td>
                <td>30 in</td>
                <td>32 in</td>
                <td>34 in</td>
                <td>37 in</td>
                <td>39 in</td>
            </tr>
            <tr>
                <th scope="row">Low Hip</th>
                <td>34 in</td>
                <td>36 in</td>
                <td>38 in</td>
                <td>40 in</td>
                <td>42 in</td>
                <td>44 in</td>
            </tr>
            <tr>
                <th scope="row">Across Shoulder</th>
                <td>17 in</td>
                <td>17 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>18 in</td>
                <td>18 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>19 in</td>
                <td>19 <sup>1</sup>⁄<sub>2</sub> in</td>
            </tr>
            <tr>
                <th scope="row">Arm Length</th>
                <td>32 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>33 <sup>1</sup>⁄<sub>4</sub> in</td>
                <td>34 in<br>86.4 cm</td>
                <td>34 <sup>3</sup>⁄<sub>4</sub> in</td>
                <td>35 <sup>5</sup>⁄<sub>8</sub> in</td>
                <td>36 <sup>1</sup>⁄<sub>2</sub> in</td>
            </tr>
            <tr class="last">
                <th scope="row">Inseam</th>
                <td>34 in</td>
                <td>34 in</td>
                <td>34 in</td>
                <td>34 in</td>
                <td>34 in</td>
                <td>34 in</td>
            </tr>
        </tbody>
    </table>
    </div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart measurments" summary="Column one has the product type, other columns show measurements.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">Sizes</th>
                <th scope="col" style="text-align: left;">28</th>
                <th scope="col" style="text-align: left;">30</th>
                <th scope="col" style="text-align: left;">32</th>
                <th scope="col" style="text-align: left;">33</th>
                <th scope="col" style="text-align: left;">34</th>
                <th scope="col" style="text-align: left;">36</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">True Waist</th>
                <td>28 in</td>
                <td>30 in</td>
                <td>32 in</td>
                <td>33 in</td>
                <td>34 in</td>
                <td>36 in</td>
            </tr>
            <tr class="last">
                <th scope="row">Low Hip</th>
                <td>34 in</td>
                <td>36 in</td>
                <td>38 in</td>
                <td>39 in</td>
                <td>40 in</td>
                <td>42 in</td>
            </tr>
        </tbody>
    </table>
    </div>
    <h2 class="underline">How to Measure</h2>
    <h3>Chest</h3>
    <p>Measure under arms around the fullest part of the chest. Be sure to keep tape level across back and comfortably loose.</p>
    <h3>True Waist</h3>
    <p>Measure around the narrowest part of your torso. This is usually right below your belly button. Be sure to keep tape level and comfortably loose.</p>
    <h3>Low Hip</h3>
    <p>Standing with your heels together measure around the fullest part of your hips. Your lower hip is about 8 inches from your waist.</p>
    <h3>Men's Arm Length</h3>
    <p>With your arm bent 90 degrees at the elbow measure from the center of the back of your neck to your wrist.</p>
    <br>
</div>

<!-- women popup -->
<div class="wrapper clearfix sizechart-popup">
    <div class="table-head">Women's Body Measurements</div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart cms-page-table measurments" summary="Column one has the product type, other columns show measurements.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">Sizes</th>
                <th scope="col" style="text-align: left;">0</th>
                <th scope="col" style="text-align: left;">1</th>
                <th scope="col" style="text-align: left;">2</th>
                <th scope="col" style="text-align: left;">3</th>
                <th scope="col" style="text-align: left;">4</th>
            </tr>
            <tr>
                <th> </th>
                <th scope="col">XS</th>
                <th scope="col">S</th>
                <th scope="col">M</th>
                <th scope="col">L</th>
                <th scope="col">XL</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">Bust</th>
                <td>31 in</td>
                <td>33 in</td>
                <td>35 in</td>
                <td>37 in</td>
                <td>39 in</td>
            </tr>
            <tr>
                <th scope="row">True Waist</th>
                <td>23 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>25 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>27 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>29 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>31 <sup>1</sup>⁄<sub>2</sub> in</td>
            </tr>
            <tr>
                <th scope="row">Low Hip</th>
                <td>34 in</td>
                <td>36 in</td>
                <td>38 in</td>
                <td>40 in</td>
                <td>42 in</td>
            </tr>
            <tr>
                <th scope="row">Across Shoulder</th>
                <td>14 in</td>
                <td>14 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>15 in</td>
                <td>15 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>16 in</td>
            </tr>
            <tr>
                <th scope="row">Arm Length</th>
                <td>23 in</td>
                <td>23 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>24 in</td>
                <td>24 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>25 in</td>
            </tr>
            <tr class="last">
                <th scope="row">Inseam</th>
                <td>34 in</td>
                <td>34 in</td>
                <td>34 in</td>
                <td>34 in</td>
                <td>34 in</td>
            </tr>
        </tbody>
    </table>
    </div>
    <div class="mobile-tbl-scroll">
    <table class="sizechart cms-page-table measurments" summary="Column one has the product type, other columns show measurements.">
        <thead>
            <tr class="strong-header">
                <th scope="row" style="text-align: left;">SIZES</th>
                <th scope="col" style="text-align: left;">24</th>
                <th scope="col" style="text-align: left;">25</th>
                <th scope="col" style="text-align: left;">26</th>
                <th scope="col" style="text-align: left;">27</th>
                <th scope="col" style="text-align: left;">28</th>
                <th scope="col" style="text-align: left;">29</th>
                <th scope="col" style="text-align: left;">30</th>
                <th scope="col" style="text-align: left;">31</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">True Waist</th>
                <td>23 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>24 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>25 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>26 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>27 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>28 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>29 <sup>1</sup>⁄<sub>2</sub> in</td>
                <td>30 <sup>1</sup>⁄<sub>2</sub> in</td>
            </tr>
            <tr class="last">
                <th scope="row">Low Hip</th>
                <td>34 in</td>
                <td>35 in</td>
                <td>36 in</td>
                <td>37 in</td>
                <td>38 in</td>
                <td>39 in</td>
                <td>40 in</td>
                <td>41 in</td>
            </tr>
        </tbody>
    </table>
    </div>
    <h2 class="underline size-subtitle">How to Measure</h2>
    <h3>Bust</h3>
    <p>Measure under arms around the fullest part of the chest. Be sure to keep tape level across back and comfortably loose.</p>
    <h3>True Waist</h3>
    <p>Measure around the narrowest part of your torso. This is usually right below your belly button. Be sure to keep tape level and comfortably loose.</p>
    <h3>Low Hip</h3>
    <p>Standing with your heels together measure around the fullest part of your hips. Your lower hip is about 8 inches from your waist.</p>
    <h3>Women's Arm Length</h3>
    <p>Measure from your shoulder to the bottom of your wrist. Be sure to keep your arm straight at your side.</p>
    <br>
</div>

<!-- Footwear POPup -->
<div class="wrapper clearfix sizechart-popup">
    <h2 class="underline">MEN'S SHOES</h2>
    <div class="mobile-tbl-scroll">
    <table class="sizechart measurments">
        <thead>
            <tr>
                <th style="text-align: left;"><strong>INTERNATIONAL EQUIVALENTS</strong></th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">US</th>
                <td style="text-align: left;">7</td>
                <td style="text-align: left;">8</td>
                <td style="text-align: left;">9</td>
                <td style="text-align: left;">10</td>
                <td style="text-align: left;">11</td>
                <td style="text-align: left;">12</td>
            </tr>
            <tr class="last">
                <th scope="row">EUROPEAN</th>
                <td style="text-align: left;">40</td>
                <td style="text-align: left;">41</td>
                <td style="text-align: left;">42</td>
                <td style="text-align: left;">43</td>
                <td style="text-align: left;">44</td>
                <td style="text-align: left;">45</td>
            </tr>
        </tbody>
    </table>
    </div>
    <h2 class="underline">WOMEN'S SHOES</h2>
    <div class="mobile-tbl-scroll">
    <table class="sizechart measurments">
        <thead>
            <tr>
                <th style="text-align: left;"><strong>INTERNATIONAL EQUIVALENTS</strong></th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
                <th> </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">US</th>
                <td style="text-align: left;">6</td>
                <td style="text-align: left;">7</td>
                <td style="text-align: left;">8</td>
                <td style="text-align: left;">9</td>
                <td style="text-align: left;">10</td>
            </tr>
            <tr class="last">
                <th scope="row">EUROPEAN</th>
                <td style="text-align: left;">36</td>
                <td style="text-align: left;">37</td>
                <td style="text-align: left;">38</td>
                <td style="text-align: left;">39</td>
                <td style="text-align: left;">40</td>
            </tr>
        </tbody>
    </table>
    </div>
    <h2 class="underline">BIRKENSTOCK SHOE SIZE CONVERSION</h2>
    <div class="mobile-tbl-scroll">
    <table class="sizechart measurments">
        <thead>
            <tr>
                <th style="text-align: left;"><strong>BIRKENSTOCK</strong></th>
                <th>36</th>
                <th>37</th>
                <th>38</th>
                <th>39</th>
                <th>40</th>
                <th>41</th>
                <th>42</th>
                <th>43</th>
                <th>44</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">US Men's </th>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td>7-7.5</td>
                <td>8-8.5</td>
                <td>9-9.5</td>
                <td>10-10.5</td>
                <td>11-11.5</td>
            </tr>
            <tr class="last">
                <th scope="row">US Women's </th>
                <td>5-5.5</td>
                <td>6-6.5</td>
                <td>7-7.5</td>
                <td>8-8.5</td>
                <td>9-9.5</td>
                <td>10-10.5</td>
                <td> </td>
                <td> </td>
                <td> </td>
            </tr>
        </tbody>
    </table>
    </div>
</div>`;
      }
    }

  
    if($("#modalProductInfo .modal-body .tt-layout-product-info").length > 0){        
      $("#modalProductInfo .modal-body .tt-layout-product-info").html(sizechart);
    }
    /* Size Chart popup - end */

    /* Filter event for Collapse - start */
    commonFuncForFilterCollapse();
    /* Filter event for Collapse - end */
  }
  if($(".filter-column").length > 0){
    if($(".filter-column").css("visibility") === "hidden"){
      $(".filter-column").css("visibility","unset");
    }
  }
}

/* ==============  Function for handle Filter data after get responce of SearchSpringAPI End   ============== */




/* ==============  Function for product data after get responce of SearchSpringAPI start   ============== */
var originalPrice = ``;
var convertedPrice = ``;
function manageProductData(arrProductData){  
  var requestPage = arrProductData['page'];
  /* render sorting options - start */  
  if(typeof(arrProductData.sorting) != "undefined" && $(".tt-sort.new-sort").length <= 0){
    var sortingOptionHTML = "";
    var activeSort = "";
    for (let sortKey = 0; sortKey < arrProductData.sorting.options.length; sortKey++) {
      if(typeof(arrProductData.sorting.options[sortKey].active) != "undefined"){
        activeSort = arrProductData.sorting.options[sortKey].field + "=" +arrProductData.sorting.options[sortKey].direction;
      }      
      sortingOptionHTML += `<option value="${arrProductData.sorting.options[sortKey].field}=${arrProductData.sorting.options[sortKey].direction}">${arrProductData.sorting.options[sortKey].label}</option>`;
    }    
    var newSortHtml = `<div class="tt-sort new-sort"><strong class="sort-by">Sort by</strong>
    <select class="sort-position" title="Sort by" aria-label="Sort by"  onchange="handleSortingChange(this);">${sortingOptionHTML}</select></div>`;
    
    $(newSortHtml).insertBefore(".tt-filters-options .tt-quantity");
    if($(".filters-mobile .filters-row-select").length > 0){
      $(".filters-mobile .filters-row-select").append(`<select class="sort-position" title="Sort by" aria-label="Sort by" onchange="handleSortingChange(this);">${sortingOptionHTML}</select>`)
    }
    if(activeSort && $(".sort-position").length > 0){      
      $(".sort-position").val(activeSort) ;
    }
  }
  /* render sorting options - end */
  
  /* render filter options - start */
  if( typeof(arrProductData.facets) != "undefined" &&  arrProductData.page <= 1){
    searchSpringFilterHandle(arrProductData.facets);  
  }  
  /* render filter options - end */

  
  /* render Product HTML - start */

  if(requestPage <= 1 && arrProductData['feturedProductResponse'] == 'Y'){
    $(".tt-product-listing .tt-col-item.featuredProduct").remove();
  }
  
  if( requestPage <= 1 && arrProductData['feturedProductResponse'] == 'N' ){
    var featuredProductHTML = '';
    const parentDiv = document.querySelector('.tt-product-listing');
    const selectedDiv = parentDiv.querySelector('.featuredProduct');    
    $(".tt-product-listing .tt-col-item.collectionProduct").remove();
    $(".tt-product-listing .tt-col-item.collectionToute").remove();
    // if(selectedDiv){
    //   parentDiv.appendChild(selectedDiv);  
    // }
  }

  var collectionToutResult = getCollectionTouts();
  var collectionTouteDeskResult = collectionToutResult.promoHTMLParse;
  var collectionTouteMobResult = collectionToutResult.promoHTMLParse_Mob;
  
  for (let i = 0; i <+ arrProductData['collectionProductResults'].length; i++) {
    var dataResult = arrProductData['collectionProductResults'][i];
    var variantHTML = "";
    
    // if(arrProductData['feturedProductResponse'] == 'N'){
    //     if(featuredProductHandle.includes(dataResult.handle)){
    //       continue;
    //     }
    // }    
    if(typeof(dataResult.variants) != "undefined"){
      var variantsArr = JSON.parse(dataResult.variants.replace(/&quot;/g,'"'));
      for (var j = 0; j < variantsArr.length; j++) {
        var dataAvailability = false;
        if(geoLocationCode != "US" && dataResult.tags.includes("Global-e Restricted")){
          dataAvailability = false;
        }else if(variantsArr[j].inventory_management === 'shopify' && variantsArr[j].inventory_policy === 'continue' && variantsArr[j].inventory_quantity <= 0){
          dataAvailability = true;
        }else{
          if(variantsArr[j].inventory_quantity > 0){
            dataAvailability = true;
          }else{
            dataAvailability = false;
          }
        }
        
        variantHTML += `<li 
              class="sizeCls"
              data-availability="${dataAvailability}"
              data-variant_availability="${dataAvailability}"
              data-var_id="${variantsArr[j].id}"
              data-pr_id="${dataResult.uid}"
              data-tag="${variantsArr[j].option1}"
              data-price="${(variantsArr[j].price * 100)}"
              data-buttonname="${(variantsArr[j].inventory_management == 'shopify' && variantsArr[j].inventory_policy == 'continue' && variantsArr[j].inventory_quantity <= 0) ? '<span>PRE-ORDER</span>' : '<span>ADD TO BAG</span>'}"
              data-compprice="${(variantsArr[j].compare_at_price * 100)}"
            >
              <a href="#">
                ${typeof(variantsArr[j].mfield_custom_product_size_description_label) != 'undefined' ? variantsArr[j].mfield_custom_product_size_description_label : variantsArr[j].option1 }
              </a>
            </li>`;
      }
    }

    var pJpg = [360,450,520,600];           
    if(typeof(dataResult.images) != 'undefined'){
      var ImgInfo = dataResult.images.split("|")[0];
      var ImgHoverInfo = dataResult.images.split("|")[1];        
      if(ImgInfo != "" && typeof(ImgInfo) != "undefined"){
          var FileExt = ImgInfo.split('.').pop();        
          var arrFileDetails = ImgInfo.split('.'+FileExt);            
          var newArrFileDetails = arrFileDetails[0].split('https:');        
          var newImgSrc = '';
          if(typeof(ImgHoverInfo) != 'undefined'){
            var FileHoverExt = ImgHoverInfo.split('.').pop();
            var arrFileDetailsHover = ImgHoverInfo.split('.'+FileHoverExt);
            var newArrFileDetailsHover = arrFileDetailsHover[0].split('https:'); 
          }          
          var newHoverImgSrc = '';
          for(var j in pJpg){
              newImgSrc = newImgSrc + newArrFileDetails[1] + "_" + pJpg[j] + "x.progressive." + FileExt + " " + pJpg[j]+"w, ";
              if(typeof(ImgHoverInfo) != 'undefined'){
                newHoverImgSrc = newHoverImgSrc + newArrFileDetailsHover[1] + "_" + pJpg[j] + "x.progressive." + FileExt + " " + pJpg[j]+"w, ";
              }
          }
      }
    }else{
      var noImgURL = `${window.location.origin}/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c`;
      var newImgSrc = '';
      var newHoverImgSrc = '';
      for(var j in pJpg){
          newImgSrc = newImgSrc + noImgURL + "_" + pJpg[j] + "x.progressive.gif.jpg" + " " + pJpg[j]+"w, ";
          if(typeof(ImgHoverInfo) != 'undefined'){
            newHoverImgSrc = newHoverImgSrc + noImgURL + "_" + pJpg[j] + "x.progressive.gif.jpg" + " " + pJpg[j]+"w, ";
          }
      }
    }

    /* Color swatch ajax on page */
    var swatchCollection = "";
    var colorSwatchCount = 0;
    var fabricTag = ``;
    var notForSale = false;

    for (let i = 0; i < dataResult.tags.length; i++) {
      if (dataResult.tags[i].toLowerCase().startsWith('fabric-')) {
          fabricTag = dataResult.tags[i].split("fabric-")[1];
      }
      if (dataResult.tags[i].toLowerCase().startsWith('not for sale')) {
          notForSale = true;
      }
    }
    
    for (let i = 0; i < dataResult.collection_name.length; i++) {
      if(dataResult.collection_name[i].toLowerCase().startsWith("swatchgroup-")){
        swatchCollection = dataResult.collection_name[i].toLowerCase();
      }
    }
    
    var dataHTML = `
      <div class="tt-col-item ${ arrProductData['feturedProductResponse'] == 'Y' ? ' collectionProduct' : 'collectionProduct'} searchSpring-Data" data-index=${i} data-elementUrl="/products/${dataResult.handle}" data-intellisuggestData="${dataResult.intellisuggestData}" data-intellisuggestSignature="${dataResult.intellisuggestSignature}" data-page=${currentPage} data-product-id="${dataResult.uid}" data-default-handle="${dataResult.handle}">
        <div class="respimgsize tt-product product-parent options-js product-nohover">
          <div class="tt-image-box">
              <button data-with-epi="true" class="swym-button custom-wishlist-button swym-add-to-wishlist-view-product product_${dataResult.uid}" aria-label="Add to Wishlist"  data-swaction="addToWishlist" data-product-id="${dataResult.uid}" data-variant-id="${JSON.parse(dataResult.variants.replace(/&quot;/g,'"'))[0].id}" data-product-url="${window.location.origin}/products/${dataResult.handle}"></button>
              ${notForSale ? '' : `<div class="size-variant"></div>`}
              <a href="/products/${dataResult.handle}" class="img-link">
                <span class="tt-img 11">
                    <img class="lazyload" data-mainimageratio="1.0" srcset="${newImgSrc}" alt="${dataResult.name}">
                </span>                 
                ${newHoverImgSrc != '' ? `
                  <span class="tt-img-roll-over">
                    <img class="lazyload" srcset="${newHoverImgSrc}" alt="${dataResult.name}">
                  </span>
                ` : '' }
              </a>
          </div>

          <div class="tt-description">
            <div class="ptitle-price-wrap">
                <h2 class="tt-title prod-thumb-title-color searchSpring-title">
                    <a href="/products/${dataResult.handle}" class="">
                      ${("false" == 'true') ? dataResult.name.substring(0, "2") + '"..."' : dataResult.name.split("-")[0] }
                    </a>
                    <span class="selected-color current-color-${dataResult.uid}">${dataResult.variant_color}</span>
                </h2>
                <div class="tt-price${notForSale ? " not-for-sale" : ""}">
                  <span class="price price-${dataResult.uid} temp-hidden">${Shopify.formatMoney((dataResult.price * 100), money_format) +" "+ localizationCurrecyCode}</span>
                  <span class="old-price old-price-${dataResult.uid} hide temp-hidden"></span></div>
            </div>

            <div class="variant-fabric">
              <div class="variant-tags">
                <div class="tt-option-block">
                  <div class="size-move-data">
                    <div class="size-position">
                      <span class="quick-add">Quick Add</span>
                      <ul class="tt-options-swatch productitem-option1-js color-opt size-ul variant-outer-${dataResult.uid}">${variantHTML}</ul>
                    </div>
                  </div>
                  <div class="color-wrap uniqueId-${dataResult.uid}">
                    <span class="no_of_clr on_hover">
                      <span class="pre-colourCount-${dataResult.uid}"></span><span class="post-colourCount-${dataResult.uid}"></span>
                    </span>
                  </div>
                </div>
              </div>

              ${fabricTag != "" ? `<div class="fabric-tag"><span>Fabric: </span><strong>${fabricTag}</strong></div>` : ''}
            </div>
            
            <div class="tt-product-inside-hover">
              <div class="tt-row-btn">
                <form action="/cart/add" data-productid="${dataResult.uid}" method="post" enctype="multipart/form-data">
                  <input type="hidden" name="id" data-productid="${dataResult.uid}" value="">
                  ${dataResult.tags.includes("Final Sale") ? `<input type="hidden" class="finalSale" name="properties[_final_sale]" data-productid="${dataResult.uid}" value="Y">` : ""}
                  <button class="tt-btn-addtocart ${ ("true" == 'true') ? 'addtocart-item-js' : ''} thumbprod-button-bg" >
                    <span>ADD TO BAG</span>
                  </button>
                </form>
              </div>            
            </div>
          </div>
        </div>
      </div>
    `;

    var currentURL = `${window.location.origin}${window.location.pathname}${location.search}`;
    var getFilterParamsFunc = getFilterParams(currentURL);
    var prodLength = $(".collectionProduct").length;
    
    if( arrProductData['feturedProductResponse'] == 'N' && getFilterParamsFunc.filterURL == ""){
      let specificDivision = collectionTouteDeskResult.querySelector(`[data-tile-position="${prodLength+1}"]`);  
      let allDesktopContentTiles = Array.from(collectionTouteDeskResult.querySelectorAll(`[data-tile-position]`));      
      let specificDivisionMob = collectionTouteMobResult.querySelector(`[data-tile-position="${prodLength+1}"]`);
      let allMobileContentTiles =  Array.from(collectionTouteMobResult.querySelectorAll(`[data-tile-position]`));

      if(specificDivision){
        let currentPosition = prodLength + 1;
        allDesktopContentTiles.sort((a, b) => {
          return parseInt(a.getAttribute('data-tile-position')) - parseInt(b.getAttribute('data-tile-position'));
        });
        allDesktopContentTiles.forEach(tile => {
          const tilePosition = parseInt(tile.dataset.tilePosition);
          if (currentPosition === tilePosition) {
            tile.setAttribute('data-page', requestPage);
            $(".tt-product-listing").append(tile);
            currentPosition += 1
          }
        });
      }

      if(specificDivisionMob){
        let currentMobPosition = prodLength + 1;
        allMobileContentTiles.sort((a, b) => {
          return parseInt(a.getAttribute('data-tile-position')) - parseInt(b.getAttribute('data-tile-position'));
        });
        allMobileContentTiles.forEach(tile => {
          const tilePosition = parseInt(tile.dataset.tilePosition);
          if (currentMobPosition === tilePosition) {
            tile.setAttribute('data-page', requestPage);
            $(".tt-product-listing").append(tile);
            currentMobPosition += 1
          }
        });
      }
    }

    if( arrProductData['feturedProductResponse'] == 'Y' ){
      $(".tt-product-listing").prepend(dataHTML);
    }else{          
       $(".tt-product-listing").append(dataHTML);
    }

  
    if(requestPage == 1 && arrProductData['feturedProductResponse'] == 'N'){
      var isLastIteration = (i === arrProductData['collectionProductResults'].length - 1);      
      if(isLastIteration){
        const specificDivisionLast = collectionTouteDeskResult.querySelector(`[data-tile-position="last"]`);
        if(specificDivisionLast){
          $(".tt-product-listing").append(specificDivisionLast);
        }
        const specificDivisionLastMob = collectionTouteMobResult.querySelector(`[data-tile-position="last"]`);
        if(specificDivisionLastMob){
          $(".tt-product-listing").append(specificDivisionLastMob);
        }
      }
    }

    // if (i == 0) {
    //   originalPrice = dataResult.price;
    //   jQuery.getJSON(window.Shopify.routes.root + 'products/'+ dataResult.handle+'.js', function(product) {        
    //     convertedPrice = product.price;
    //   });    
    // }    
    
    $.ajax({
      url: `/pages/collection-colorswatch/${swatchCollection};${dataResult.uid};${dataResult.handle}`,
      type: 'GET',        
      dataType: "html",
      success: function(data) {

        data = $.parseHTML(data);
        var uniqueId = $(data).find('#uniqueId').html();

        $(".variant-outer-"+uniqueId+" li").each(function( index ) {
          var curVarId = $(this).attr('data-var_id');
          var newPrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .price').html();
          var newComparePrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .comp-price').html();
          $(this).attr('data-price', newPrice);
          $(this).attr('data-compprice', newComparePrice); 
        });
        
        var colorSwatchCount = $(data).find('#swatchCount').html();
        var preHtml = colorSwatchCount > 0 ? colorSwatchCount : "No";
        var postHtml = colorSwatchCount === 1 ? "&nbsp;color available" : "&nbsp;colors available";
        $('.pre-colourCount-' + uniqueId).html(preHtml);
        $('.post-colourCount-' + uniqueId).html(postHtml);          
        var colorSwatchBox = $(data).find('#colorSwatch-box').html();
        $('.tt-description .color-wrap.uniqueId-'+uniqueId).append(colorSwatchBox);

        var currentColor = $(data).find("#colorSwatch-box li.active a").attr("data-color");
        if(typeof(currentColor) != "undefined"){
          $('.current-color-'+uniqueId).html(currentColor);
        }

        var currentPrice = $(data).find("#productPrice").html();
        var currentCompPrice = $(data).find("#productCompPrice").html();

        if(cartCurrencySymbol != "$"){
          $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format));
          $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format));
        }else{
          $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format) +" "+ localizationCurrecyCode);
          $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format) +" "+ localizationCurrecyCode);
        }
        
        $('.tt-price .price-'+uniqueId).removeClass("temp-hidden");
        $('.tt-price .old-price-'+uniqueId).removeClass("temp-hidden");

        if(parseInt(currentCompPrice) > parseInt(currentPrice)){
           $('.tt-price .old-price-'+uniqueId).removeClass('hide');
           $('.tt-price .price-'+uniqueId).addClass('new-price');
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error("Error fetching line-item-list content:", errorThrown);
      }
    });
  }


  /* render Product HTML - end */
  setTimeout(() => {
    // color_update(true);
    color_swatches_function();  
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  },1000);
  

  /* load More Button HTML Changes start */
  var paginationHTML = ``;
  var tag = '';
  var outerTag = '';

  if("autoscroll" == "autoscroll"){    
    tag = "autoscroll";
    outerTag = "autoscroll_yes";
  }else{
    outerTag = "displayshowmore";
  }
  if($(".tt_product_showmore").length > 0){
    $(".tt_product_showmore").remove();  
  }

  if( typeof( arrProductData['pagination'].nextPage) != "undefined" && arrProductData['pagination'].nextPage > 0 ){
    paginationHTML = `<div class="text-center tt_product_showmore infinitybutton ${outerTag}">
        <div class="show-more">
            <a href="javascript:void(0);" class="btn btn-border ttshowmorestyle ${tag}" onClick="javascript:manageCollectionPageData(${arrProductData['pagination'].nextPage});" >Load More</a>              
        </div>
    </div>`;
  }else{
      paginationHTML = `<div class="text-center tt_product_showmore infinitybutton ${outerTag}">
          <div class="show-more tt_item_all_js">
            <a href="javascript:void(0);" class="btn btn-border01 ttshowmorestyle disable">NO MORE PRODUCTS</a>
          </div>
      </div>`;
  }
  $(paginationHTML).insertAfter(".tt-product-listing");

  // if(requestPage <= 1){
  //   priceFilterConvert();    
  // }

  if($(".product-column .title-in-line").length > 0){
    if($(".product-column .title-in-line").css("visibility") === "hidden"){
      $(".product-column .title-in-line").css("visibility","unset");
      $(".tt-title-mob.mobt-show").css("visibility","unset");
    }
  } 
  collectionSizeChart();

  $('.tt-col-item.collectionProduct').each(function( index ) {
    if(!$(this).hasClass("intellisuggestdata-binded")){
      $(this).on('click', function(){

        var data = $(this).attr('data-intellisuggestdata');
        data = (data !== '') ? data : undefined;
        var signature = $(this).attr('data-intellisuggestsignature');
        signature = (signature !== '') ? signature : undefined;
        var elementURL = $(this).attr('data-elementUrl');

        IntelliSuggest.clickItem($(this), { siteId: searchSpringId , intellisuggestData : data , intellisuggestSignature : signature, href: elementURL });
      });
      $(this).addClass("intellisuggestdata-binded");
    }
  });
  /* load More Button HTML Changes end */
}


function priceFilterConvert(){
  var convertPriceRate = setInterval(function () {
      if(convertedPrice != ""){        
        clearInterval(convertPriceRate);        
        var convertedPriceFormat = parseInt(convertedPrice) / 100;      
        var conversionRateTemp = (parseInt(convertedPriceFormat) / parseInt(originalPrice));    
        if($(".range-input .range-min").length > 0){
          var priceValueMin = $(".range-input .range-min").val();
          var priceValueMax = $(".range-input .range-max").val();
          
          var newPriceValueMin = Math.ceil((parseInt(priceValueMin) * conversionRateTemp));
          var newPriceValueMax = Math.ceil((parseInt(priceValueMax) * conversionRateTemp));

          var filterField = $(".range-input .range-min").attr('data-filterfield');
          var filterStep = $(".range-input .range-min").attr('step');
          var rangeInputHTML = `
          <input type="range" id="rangeMin" data-currencyRate=${conversionRateTemp} data-filterfield=${filterField} class="range-min" min=${newPriceValueMin} max=${newPriceValueMax} data-value=${newPriceValueMin} value=${newPriceValueMin} step="1" />
          <input type="range" id="rangeMax" data-currencyRate=${conversionRateTemp} data-filterfield=${filterField} class="range-max" min=${newPriceValueMin} max=${newPriceValueMax} data-value=${newPriceValueMax} value=${newPriceValueMax} step="1" />`;

          $(".range-input").html(rangeInputHTML);
          
          var priceInputMin = `<input type="number" id="inputMin" data-filterfield=${filterField} class="input-min" value=${newPriceValueMin} data-value=${newPriceValueMin} />`;
          var priceInputMax = `<input type="number" id="inputMax" data-filterfield=${filterField} class="input-max" value=${newPriceValueMax} data-value=${newPriceValueMax} />`;
          $(".price-input .field.min").html(priceInputMin);
          $(".price-input .field.max").html(priceInputMax);  
          
          if($(".filter-type-slider").length > 0){
            const rangeInput = document.querySelectorAll(".range-input input");
            const priceInput = document.querySelectorAll(".price-input input");
            const range = document.querySelector(".slider .progress");
            let priceGap = 10;         
                        
            priceInput.forEach((input) => {
              input.addEventListener("blur", (e) => {
                var minPrice = parseInt(priceInput[0].value);
                var maxPrice = parseInt(priceInput[1].value);

                if(parseInt(minPrice) < parseInt(priceInput[0].getAttribute("data-value"))){
                  priceInput[0].value = parseInt(priceInput[0].getAttribute("data-value"));
                  minPrice = parseInt(priceInput[0].getAttribute("data-value"));
                  return false;
                }

                if(parseInt(maxPrice) > parseInt(priceInput[1].getAttribute("data-value"))){
                  priceInput[1].value = parseInt(priceInput[1].getAttribute("data-value"));
                  maxPrice = parseInt(priceInput[1].getAttribute("data-value"));
                  return false;
                }
                
                let minPriceFixed = parseInt(priceInput[0].getAttribute("data-value"));
                let maxPriceFixed = parseInt(priceInput[1].getAttribute("data-value"));                
                let rangePrice = maxPriceFixed - minPriceFixed;
                
                if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
                  if (e.target.className === "input-min") {            
                    rangeInput[0].value = minPrice;
                    range.style.left = ((minPrice - minPriceFixed) / rangePrice) * 100 + "%";                    
                  } else {
                    rangeInput[1].value = maxPrice;
                    range.style.right = 100 - ((maxPrice - minPriceFixed) / rangePrice) * 100 + "%";                    
                  }
                }
                
                if(e.target.className === "input-min"){
                  handleFilterClick(rangeInput[0]);                  
                }else{
                  handleFilterClick(rangeInput[1]);                  
                }
              });
            });
            
            rangeInput.forEach((input) => {
              input.addEventListener("input", (e) => {
                let minVal = parseInt(rangeInput[0].value);
                let maxVal = parseInt(rangeInput[1].value);

                if(parseInt(minVal) < parseInt(rangeInput[0].getAttribute("data-value"))){
                  rangeInput[0].value = parseInt(rangeInput[0].getAttribute("data-value"));                  
                }
        
                let minValFixed = parseInt(rangeInput[0].getAttribute("data-value"));
                let maxValFixed = parseInt(rangeInput[1].getAttribute("data-value"));
                let rangeValue = maxValFixed - minValFixed;
        
                if (maxVal - minVal < priceGap) {
                  if (e.target.className === "range-min") {
                    rangeInput[0].value = maxVal - priceGap;
                  } else {
                    rangeInput[1].value = minVal + priceGap;
                  }
                } else {                  
                  priceInput[0].value = minVal;
                  priceInput[1].value = maxVal;        
                  range.style.left = ((minVal - minValFixed) / rangeValue) * 100 + "%";
                  range.style.right = 100 - ((maxVal - minValFixed) / rangeValue) * 100 + "%";
                }
              });
            });

            var priceRangeMinSlider = document.getElementById("rangeMin");
            var priceRangeMaxSlider = document.getElementById("rangeMax");
            priceRangeMinSlider.addEventListener("change", function() {        
                handleFilterClick(this);
            });
            priceRangeMaxSlider.addEventListener("change", function() {        
                handleFilterClick(this);        
            });
        
            // var priceRangeMinInput = document.getElementById("inputMin");
            // var priceRangeMaxInput = document.getElementById("inputMax");
        
            // priceRangeMinInput.addEventListener("blur", function() {                
            //     handleFilterClick(priceRangeMinSlider);
            // });
            // priceRangeMaxInput.addEventListener("blur", function() {        
            //     handleFilterClick(priceRangeMaxSlider);        
            // });
          }
          if($(".filter-type-slider .wrapper").length > 0){
            $(".filter-type-slider .wrapper").css("display","block");
          }          
        }
      }      
    }, 1000);
}

/* ==============  Function for product data after get responce of SearchSpringAPI end   ============== */


/* ==============  Function for common data after get responce of SearchSpringAPI start   ============== */
function manageCommonData(arrCommonData){  
  if(arrCommonData['apiRequestData'] == 'trending'){
      /* render trending data - start */  
      if(arrCommonData['responseResultData']['trending']['queries'].length > 0){
        var queryDataArr = arrCommonData['responseResultData']['trending']['queries'];        
        var trendingSearchTerm = '';
        var trendingSearchTermMob = '';
        var trending_remove_terms_arr = searchSpring_trending_remove_terms.toLowerCase().split(",");
        var trending_update_terms_arr = searchSpring_trending_update_terms.toLowerCase().split(",");
        var keyValueArray = {};
        if (trending_update_terms_arr.length > 0) {            
            trending_update_terms_arr.forEach(terms => {
                var [key, value = ""] = terms.split(':').map(item => item.trim());
                keyValueArray[key.trim()] = value;
            });
        }
        for( var prokey in  queryDataArr ){
          var queryData = queryDataArr[prokey];
          if(trending_remove_terms_arr.length > 0){
            if(trending_remove_terms_arr.includes(queryData.searchQuery.toLowerCase())){            
              continue;
            }
          }
          var searchTerms = queryData.searchQuery.toLowerCase();
          if (Object.keys(keyValueArray).length > 0 && keyValueArray.hasOwnProperty(searchTerms)) {
              searchTerms = keyValueArray[searchTerms];
          }
          trendingSearchTerm += `<li class="nav-item"><a href="/pages/${searchPageRedirection}?q=${searchTerms}" title="${searchTerms}">${searchTerms}</a></li>`;
          trendingSearchTermMob += `<li class="mobile-nav-item"><a href="/pages/${searchPageRedirection}?q=${searchTerms}" title="${searchTerms}">${searchTerms}</a></li>`
        }        
        $(".search-seggestion-outer .search-navList.trending-search").html(trendingSearchTerm);
        $(".mobile-search-suggest-outer .mobile-search-inner-trending .mobile-search-navList").html(trendingSearchTermMob);
      }else{
        var queryDataArr = [
            { "searchQuery": "shirt", "popularity": 1 },
            { "searchQuery": "pent", "popularity": 2 },      
        ];
        var trendingSearchTerm = '';
        var trendingSearchTermMob = '';
        for( var prokey in  queryDataArr ){
          var queryData = queryDataArr[prokey];      
          trendingSearchTerm += `<li class="nav-item"><a href="/pages/${searchPageRedirection}?q=${queryData.searchQuery}" title="${queryData.searchQuery}">${queryData.searchQuery}</a></li>`;
          trendingSearchTermMob += `<li class="mobile-nav-item"><a href="/pages/${searchPageRedirection}?q=${queryData.searchQuery}" title="${queryData.searchQuery}">${queryData.searchQuery}</a></li>`
        }
        $(".search-seggestion-outer .search-navList.trending-search").html(trendingSearchTerm);        
        $(".mobile-search-suggest-outer .mobile-search-inner-trending .mobile-search-navList").html(trendingSearchTermMob);
      }
      /* render trending data - end */
  }
  
  if(arrCommonData['apiRequestData'] == 'trendingProductRec'){
    /* render trending product data - start */      
      if(arrCommonData['responseResultData'][0]['results'].length > 0){
        var trendingProduct = '';
        var queryDataArr = arrCommonData['responseResultData'][0]['results'];
        for( var prokey in  queryDataArr ){
          var queryData = queryDataArr[prokey];          
          jQuery.getJSON(window.Shopify.routes.root + 'products/'+ queryData.mappings.core.url+'.js', function(product) { 

            if(cartCurrencySymbol == "$"){
              $(`.search-trending-product .trending-product-${product.id}`).html(Shopify.formatMoney(product.price, money_format) +" "+ localizationCurrecyCode);
              $(`.search-trending-product .product-match-compare-price-trending.search-product-${product.id}`).html(Shopify.formatMoney(product.compare_at_price, money_format) +" "+ localizationCurrecyCode);              
            }else{
              $(`.search-trending-product .trending-product-${product.id}`).html(Shopify.formatMoney(product.price, money_format));
              $(`.search-trending-product .product-match-compare-price-trending.search-product-${product.id}`).html(Shopify.formatMoney(product.compare_at_price, money_format));
            }
            if(parseInt(product.compare_at_price) > parseInt(product.price) ){
              $(`.search-trending-product .product-match-compare-price-trending.search-product-${product.id}`).removeClass('hide');
            }
          });
          trendingProduct += `<div class="search-product-item">
            <div class="search-product-wrap">
              <div class="search-product-card">
                <div class="search-product__image">
                  <a href="/products/${typeof(queryData.mappings.core.url) != 'undefined' ? queryData.mappings.core.url : ''}">
                    <div class="search-image__aspect">
                      <img src="${queryData.mappings.core.imageUrl}" alt="${queryData.mappings.core.name}" width="" height="">
                    </div>
                  </a>
                </div>
                <div class="search-product__content">
                  <div class="search-product-title-wrapper">
                    <div class="search-product-title-item-wrapper">
                      <h3 class="search-product-title">
                        <a class="search-product-title-link">${queryData.mappings.core.name.split('-')[0]}</a>
                      </h3>
                      <span class="search-product-option-label">${typeof(queryData.mappings.core.name.split('-')[1]) != "undefined" ? queryData.mappings.core.name.split('-')[1] : ""}</span>                      
                    </div>
                    <div class="search-product--price__price-wrapper${queryData.attributes.tags.includes('not for sale') ? " not-for-sale" : ""}">
                      <span class="search-product--price-price product-match-price-trending trending-product-${queryData.id}"></span>
                      <span class="search-product--price-price product-match-compare-price-trending search-product-${queryData.id} hide"></span>
                    </div>
                  </div>
                </div>                  
              </div>
            </div>
          </div>`;
        }
        $(".search-seggestion-outer .searchGrid-right .search-product--items.search-trending-product").html(trendingProduct);
      }
    /* render trending product data - end */
  }


  if(arrCommonData['apiRequestData'] == 'suggestApi'){
    if(arrCommonData['responseResultData']['alternatives'].length > 0){
      var suggestApiRender = '';
      var suggestApiRenderMob = '';      
      var queryDataArr = arrCommonData['responseResultData']['alternatives'];      
      for( var prokey in  queryDataArr ){
        var queryData = queryDataArr[prokey];
        var highlightedSuggestion = queryData.text.replace(new RegExp(arrCommonData['apiRequestInput'], "gi"), match => `<span class="highlight">${match.trim()}</span>`);        
        suggestApiRender += `<li class="nav-item">
              <a href="/pages/${searchPageRedirection}?q=${queryData.text}" title="${queryData.text}">
                ${highlightedSuggestion}
              </a>
          </li>`;
        suggestApiRenderMob += `<li class="mobile-nav-item">
          <a href="/pages/${searchPageRedirection}?q=${queryData.text}" title="${queryData.text}">
            ${highlightedSuggestion}
          </a></li>`;
      }      
      $(".search-seggestion-outer .searchGrid-left .grid-title").html('Search suggestions');
      $(".search-seggestion-outer .search-navList.search-suggest").html(suggestApiRender);      
      $(".mobile-search-suggest-outer .mobile-search-inner-suggestion .mobile-search-navList").html(suggestApiRenderMob);

      //$(".search-seggestion-outer .viewAll-search").html('View All Results for <b><u>'+arrCommonData['apiRequestInput']+ '</u></b>').attr("href", `/pages/${searchPageRedirection}?q=${arrCommonData['apiRequestInput']}`);
      if($(".tt-mobile-header").css("display") !== "none"){
        $(".mobile-search-suggest-outer .mobile-search-inner-trending").css('display',"none"); 
        $(".mobile-search-suggest-outer .mobile-search-inner-suggestion").css('display',"block");
      }
      $(".search-seggestion-outer .search-navList.trending-search").css('display','none');
      $(".search-seggestion-outer .search-navList.search-suggest").css('display','block');
      suggestApiFlagNoRes = false;
      if(!$(".mobile-search-suggest-outer").is(":visible")){
        $(".mobile-search-suggest-outer").css('display',"block");  
      }
    }else{
      // if($(".mobile-search-suggest-outer").is(":visible")){
      //   $(".mobile-search-suggest-outer").css('display',"none");  
      // }
      $(".mobile-search-inner .mobile-nav-item .highlight").css('font-weight', 'unset');
      $(".search-seggestion-outer .searchGrid-left .nav-item .highlight").css('font-weight', 'unset');
      suggestApiFlagNoRes = true;
    }
  }

  if(arrCommonData['apiRequestData'] == 'searchResult'){
    if(arrCommonData['responseResultData']['results'].length > 0){
      var searchResultProduct = '';
        var queryDataArr = arrCommonData['responseResultData']['results'];        
        for( var prokey in  queryDataArr ){
          var queryData = queryDataArr[prokey];
          jQuery.getJSON(window.Shopify.routes.root + 'products/'+ queryData.handle+'.js', function(product) {
            if(cartCurrencySymbol == "$"){
              $(`.search-products .product-match-price.search-product-${product.id}`).html(Shopify.formatMoney(product.price, money_format) +" "+ localizationCurrecyCode);
              $(`.search-products .product-match-compare-price.search-product-${product.id}`).html(Shopify.formatMoney(product.compare_at_price, money_format) +" "+ localizationCurrecyCode);
            }else{
              $(`.search-products .product-match-price.search-product-${product.id}`).html(Shopify.formatMoney(product.price, money_format));
              $(`.search-products .product-match-compare-price.search-product-${product.id}`).html(Shopify.formatMoney(product.compare_at_price, money_format));
            }
            if(parseInt(product.compare_at_price) > parseInt(product.price) ){
              $(`.search-products .product-match-compare-price.search-product-${product.id}`).removeClass('hide');
            }
          });
          searchResultProduct += `<div class="search-product-item">
            <div class="search-product-wrap">
              <div class="search-product-card">
                <div class="search-product__image">
                  <a href="/products/${typeof(queryData.handle) != 'undefined' ? queryData.handle : ''}" data-intellisuggestData="${queryData.intellisuggestData}" data-intellisuggestSignature="${queryData.intellisuggestSignature}">
                    <div class="search-image__aspect">
                      <img src="${typeof(queryData.imageUrl) != 'undefined' ? queryData.imageUrl : `${window.location.origin}/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_600x.progressive.gif.jpg`}" alt="${queryData.name}" width="" height="">
                    </div>
                  </a>
                </div>
                <div class="search-product__content">
                  <div class="search-product-title-wrapper">
                    <div class="search-product-title-item-wrapper">
                      <h3 class="search-product-title">
                        <a class="search-product-title-link">${queryData.name.split('-')[0]}</a>
                      </h3>
                      <span class="search-product-option-label">${typeof(queryData.name.split('-')[1]) != "undefined" ? queryData.name.split('-')[1] : ""}</span>                      
                    </div>
                    <div class="search-product--price__price-wrapper${queryData.tags.includes('not for sale') || queryData.tags.includes('Not For Sale') ? " not-for-sale" : ""}">
                      <span class="search-product--price-price product-match-price search-product-${queryData.uid}"></span>
                      <span class="search-product--price-price product-match-compare-price search-product-${queryData.uid} hide"></span>
                    </div>
                  </div>
                </div>                  
              </div>
            </div>
          </div>`;
        }
        //$(".search-seggestion-outer .viewAll-search").html('View All Results for <b><u>'+arrCommonData['apiRequestInput']+ '</u></b>').attr("href", `/pages/${searchPageRedirection}?q=${arrCommonData['apiRequestInput']}`);
        $(".search-seggestion-outer .searchGrid-right .grid-title").html('Product matches');
        $(".search-seggestion-outer .searchGrid-right .no-product").css("display","none");
        $(".search-seggestion-outer .searchGrid-right .search-product--items.search-products").html(searchResultProduct);
        $(".search-seggestion-outer .searchGrid-right .search-product--items.search-trending-product").css('display','none');
        $(".search-seggestion-outer .searchGrid-right .search-product--items.search-products").css('display','block');
        searchResultFlagNoRes = false;
        if($(".search-products .search-product-item").length > 0){
          $(".search-products .search-product__image a").each(function( index ) {
            if(!$(this).hasClass("data-intellisuggestdata-autocomplete")){
              $(this).on('click', function(){
                var data = $(this).attr('data-intellisuggestdata');
                var signature = $(this).attr('data-intellisuggestsignature');
                var elementURL = $(this).attr('href');
              
                IntelliSuggest.clickItem($(this), { siteId: searchSpringId , intellisuggestData : data , intellisuggestSignature : signature, href: elementURL });
              
              });
              $(this).addClass("data-intellisuggestdata-autocomplete");
            }
          });         
        }
    }else{
      searchResultFlagNoRes = true;
    }    
  }
 
  // if(suggestApiFlagNoRes && searchResultFlagNoRes){
  //   if($(".bg-opacity").length > 0){
  //     $(".bg-opacity").click();
  //   }
  // }
}
/* ==============  Function for common data after get responce of SearchSpringAPI end   ============== */


/* ==============  Function for product page data of SearchSpringAPI start   ============== */
function manageProductPageData(arrProductPageData){
  if(arrProductPageData['ProductResults'].length > 0){
    callBeaconApiForProductRender(arrProductPageData);
    var ProductRecommendation = '';
    var queryProductDataArr = arrProductPageData['ProductResults'];
    
    for( var prokey in  queryProductDataArr ){
      
      var queryData = queryProductDataArr[prokey];
      
      if(typeof(queryData.attributes.variants) != "undefined"){
        var variantsArr = JSON.parse(queryData.attributes.variants.replace(/&quot;/g,'"'));
        var variantHTML = "";
        for (var j = 0; j < variantsArr.length; j++) {
          var dataAvailability = false;
          if(geoLocationCode != "US" && queryData.attributes.tags[i].includes("Global-e Restricted")){
            dataAvailability = false;
          }else if(variantsArr[j].inventory_management === 'shopify' && variantsArr[j].inventory_policy === 'continue' && variantsArr[j].inventory_quantity <= 0){
            dataAvailability = true;
          }else{
            if(variantsArr[j].inventory_quantity > 0){
              dataAvailability = true;
            }else{
              dataAvailability = false;
            }
          }
          
          variantHTML += `<li 
                class="sizeCls"
                data-availability="${dataAvailability}"
                data-variant_availability="${dataAvailability}"
                data-var_id="${variantsArr[j].id}"
                data-pr_id="${queryData.mappings.core.uid}"
                data-tag="${variantsArr[j].option1}"
                data-price="${(variantsArr[j].price * 100)}"
                data-buttonname="${(variantsArr[j].inventory_management == 'shopify' && variantsArr[j].inventory_policy == 'continue' && variantsArr[j].inventory_quantity <= 0) ? '<span>PRE-ORDER</span>' : '<span>ADD TO BAG</span>'}"
                data-compprice="${(variantsArr[j].compare_at_price * 100)}"
              >
                <a href="#">
                  ${typeof(variantsArr[j].mfield_custom_product_size_description_label) != 'undefined' ? variantsArr[j].mfield_custom_product_size_description_label : variantsArr[j].option1 }
                </a>
              </li>`;
        }
      }
      
      var swatchCollection = "";
      var fabricTag = "";
      var colorSwatchCount = 0;
      var notForSale = false;
      for (let i = 0; i < queryData.attributes.tags.length; i++) {
        /*if(queryData.attributes.tags[i].includes('swatchgroup-')){
          swatchCollection = queryData.attributes.tags[i];
        }*/

        if (queryData.attributes.tags[i].toLowerCase().startsWith('fabric-')) {
          fabricTag = queryData.attributes.tags[i].split("fabric-")[1];
        }
        if (queryData.attributes.tags[i].toLowerCase().startsWith('not for sale')) {
          var notForSale = true;
        }
      }

      for (let i = 0; i < queryData.attributes.collection_name.length; i++) {
        if(queryData.attributes.collection_name[i].toLowerCase().startsWith("swatchgroup-")){
          swatchCollection = queryData.attributes.collection_name[i].toLowerCase();
        }
      }
      
      ProductRecommendation += `
        <div class="col-2 col-md-4 col-lg-3 tt-col-item product-outer-${queryData.mappings.core.uid}">
          <div class="respimgsize tt-product product-parent options-js product-nohover">
            <div class="tt-image-box">
              <button data-with-epi="true" class="swym-button custom-wishlist-button swym-add-to-wishlist-view-product product_${queryData.mappings.core.uid}" data-swaction="addToWishlist" aria-label="Add to Wishlist"  data-product-id="${queryData.mappings.core.uid}" data-variant-id="${JSON.parse(queryData.attributes.variants.replace(/&quot;/g,'"'))[0].id}" data-product-url="${window.location.origin}/products/${queryData.mappings.core.url}"></button>
              ${notForSale ? '' : `<div class="size-variant"></div>`} 
              <a href="/products/${queryData.mappings.core.url}" class="image-loaded">
                <span class="tt-img 11">
                    <img class="lazyload" data-mainimageratio="1.0" srcset="${queryData.mappings.core.imageUrl}" alt="${queryData.mappings.core.name}">
                </span>  
                <span class="tt-img-roll-over">
                    <img class="lazyload" srcset="${queryData.mappings.core.thumbnailImageUrl}" alt="${queryData.mappings.core.name}">
                </span>
              </a>
            </div>

            <div class="tt-description">
              <div class="ptitle-price-wrap">
                  <h2 class="tt-title prod-thumb-title-color">
                      <a href="/products/${queryData.mappings.core.url}" class="image-title-loaded"> 
                        ${queryData.mappings.core.name.split("-")[0]}
                      </a>
                      <span class="selected-color current-color-${queryData.mappings.core.uid}">Thunder/Mist/Hazel/Ivory</span>
                  </h2>
                  <div class="tt-price${notForSale ? " not-for-sale" : ""}">
                      <span class="price price-${queryData.mappings.core.uid}">${Shopify.formatMoney((queryData.mappings.core.price * 100), money_format) +" "+ localizationCurrecyCode}</span>
                      <span class="old-price old-price-${queryData.mappings.core.uid} hide">$1,150.00 CAD </span>
                  </div>
              </div>

              <div class="variant-fabric">
                <div class="variant-tags">
                  <div class="tt-option-block">
                    <div class="size-move-data">
                      <div class="size-position">
                        <span class="quick-add">Quick Add</span>
                        <ul class="tt-options-swatch productitem-option1-js color-opt size-ul variant-outer-${queryData.mappings.core.uid}">${variantHTML}</ul>
                      </div>
                    </div>
                    <div class="color-wrap uniqueId-${queryData.mappings.core.uid}">
                      <span class="no_of_clr on_hover">
                        <span class="pre-colourCount-${queryData.mappings.core.uid}"></span>
                        <span class="post-colourCount-${queryData.mappings.core.uid}"></span>
                      </span>                    
                    </div>
                  </div>
                </div>
                ${fabricTag != "" ? `<div class="fabric-tag"><span>Fabric: </span><strong>${fabricTag}</strong></div>` : ''}                
              </div>

              <div class="tt-product-inside-hover">
              	<div class="tt-row-btn">
              	  <form action="/cart/add" data-productid="${queryData.id}" method="post" enctype="multipart/form-data">
              		<input type="hidden" name="id" data-productid="${queryData.id}" value="">
                    ${queryData.attributes.tags.includes("Final Sale") ? `<input type="hidden" class="finalSale" name="properties[_final_sale]" data-productid="${queryData.id}" value="Y">` : ""} 
              		<button class="tt-btn-addtocart ${ ("true" == 'true') ? 'addtocart-item-js' : ''} thumbprod-button-bg" >
              		  <span>ADD TO BAG</span>
              		</button>
              	  </form>
              	</div>
              </div>
              
            </div>
          </div>
        </div>
      `;

      /* Color swatch ajax on page */      
      $.ajax({
        url: `/pages/collection-colorswatch/${swatchCollection};${queryData.mappings.core.uid};${queryData.mappings.core.url}`,
        type: 'GET',        
        dataType: "html",
        success: function(data) {
  
          data = $.parseHTML(data);
      
          var uniqueId = $(data).find('#uniqueId').html();

          $(".variant-outer-"+uniqueId+" li").each(function( index ) {
            var curVarId = $(this).attr('data-var_id');
            var newPrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .price').html();
            var newComparePrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .comp-price').html();
            $(this).attr('data-price', newPrice);
            $(this).attr('data-compprice', newComparePrice);
          });
          var colorSwatchCount = $(data).find('#swatchCount').html();          
          var preHtml = colorSwatchCount > 0 ? colorSwatchCount : "No";
          var postHtml = colorSwatchCount === 1 ? "&nbsp;color available" : "&nbsp;colors available";
          $('.pre-colourCount-' + uniqueId).html(preHtml);
          $('.post-colourCount-' + uniqueId).html(postHtml);          
          var colorSwatchBox = $(data).find('#colorSwatch-box').html();
          $('.tt-description .color-wrap.uniqueId-'+uniqueId).append(colorSwatchBox);
  
          var currentColor = $(data).find("#colorSwatch-box li.active a").attr("data-color");
          if(typeof(currentColor) != "undefined"){
            $('.current-color-'+uniqueId).html(currentColor);
          }
  
          var currentPrice = $(data).find("#productPrice").html();
          var currentCompPrice = $(data).find("#productCompPrice").html();

          if(cartCurrencySymbol != "$"){
            $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format));
            $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format));
          }else{
            $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format) +" "+ localizationCurrecyCode);
            $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format) +" "+ localizationCurrecyCode);
          }
          $('.tt-price .price-'+uniqueId).removeClass("temp-hidden");
          $('.tt-price .old-price-'+uniqueId).removeClass("temp-hidden");

          if(parseInt(currentCompPrice) > parseInt(currentPrice)){
             $('.tt-price .old-price-'+uniqueId).removeClass('hide');
             $('.tt-price .price-'+uniqueId).addClass('new-price');
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error fetching line-item-list content:", errorThrown);
        }
      });
      
    }
    
    if($('.product-recommendation').length > 0){
      $('.product-recommendation').append(ProductRecommendation);
      /* carusel */
      $('.product-recommendation').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: true,
        responsive: [{
      	breakpoint: 1025,
      	settings: {
      	   slidesToShow: 3,
      	   slidesToScroll: 3
      	}
        },
      	{
      	 breakpoint: 791,
      	 settings: {
      	   slidesToShow: 2,
      		slidesToScroll: 2
      	 }
      	},{
      	 breakpoint: 399,
      	 settings: {
      	   slidesToShow: 1,
      		slidesToScroll: 1
      	 }
      	}]
      });
    }

    setTimeout(() => {
      // color_update();
      color_swatches_function();
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    },1000);
    collectionSizeChart();
  }
}
/* ==============  Function for product page data of SearchSpringAPI end   ============== */


/* ==============  Function for search Page data after get responce of SearchSpringAPI start   ============== */
var originalPriceSearch = ``;
var convertedPriceSearch = ``;
var arrTagForRemoveProduct = ['not for sale', 'push to shiphero', 'exclude from search'];
function manageSearchData(arrSearchData){
  if(typeof(arrSearchData['searchProductResults']) != "undefined"){
    /* render sorting options - start */
    if(typeof(arrSearchData.sorting) != "undefined" && $(".tt-sort.new-sort").length <= 0){
      var sortingOptionHTML = "";
      var activeSearchSort = "";
      for (let sortKey = 0; sortKey < arrSearchData.sorting.options.length; sortKey++) {
        if(typeof(arrSearchData.sorting.options[sortKey].active) != "undefined"){
          activeSearchSort = arrSearchData.sorting.options[sortKey].field + "=" +arrSearchData.sorting.options[sortKey].direction;
        } 
        sortingOptionHTML += `<option value="${arrSearchData.sorting.options[sortKey].field}=${arrSearchData.sorting.options[sortKey].direction}">${arrSearchData.sorting.options[sortKey].label}</option>`;
      }
      var newSortHtml = `<div class="tt-sort new-sort"><strong class="sort-by">Sort by</strong>
      <select class="sort-position" title="Sort by" aria-label="Sort by" onchange="handleSortingChange(this);">${sortingOptionHTML}</select></div>`;
  
      var newSortMob = `<div class="tt-collapse open tt-filter-detach-option">
        <div class="tt-collapse-content">
          <div class="filters-mobile">
            <div class="filters-row-select">
    			<strong class="sort-by">Sort By</strong>
              <select class="sort-position" title="Sort by" aria-label="Sort by" onchange="handleSortingChange(this);">${sortingOptionHTML}</select>
            </div>
          </div>
        </div>
      </div>`;
      
      $(newSortHtml).insertBefore(".tt-filters-options .tt-quantity");
      if($(".filter-column").length > 0){
        $(".filter-column").append(newSortMob);      
      }
      if(activeSearchSort && $(".sort-position").length > 0){      
        $(".sort-position").val(activeSearchSort) ;
      }
    }
    /* render sorting options - end */
  
    
    /* render filter options - start */
    if( typeof(arrSearchData.facets) != "undefined"){
      searchSpringFilterHandle(arrSearchData.facets);  
    }    
    /* render filter options - end */
      
    $(".search-page .no-banner-title").html(`SHOWING ${arrSearchData['pagination']['totalResults']} RESULTS${arrSearchData['q'].trim() != '' ? ' FOR "'+arrSearchData['q']+'"' : ''}.`);
  
    if($(".tt-title-mob.mobt-show").length > 0){
      $(".tt-title-mob.mobt-show").html(`SHOWING ${arrSearchData['pagination']['totalResults']} RESULTS${arrSearchData['q'].trim() != '' ? ' FOR "'+arrSearchData['q']+'"' : ''}.`);
    }
  
    if( arrSearchData['page'] <= 1){
      $(".tt-product-listing .tt-col-item").remove();
    }  
    for (let i = 0; i <+ arrSearchData['searchProductResults'].length; i++) {
      var searchDataResult = arrSearchData['searchProductResults'][i];    
      var variantSearchHTML = '';
      if(typeof(searchDataResult.variants) != "undefined"){
        var variantsArr = JSON.parse(searchDataResult.variants.replace(/&quot;/g,'"'));
        for (var j = 0; j < variantsArr.length; j++) {
          var dataAvailability = false;
          if(geoLocationCode != "US" && searchDataResult.tags.includes("Global-e Restricted")){
            dataAvailability = false;
          }else if(variantsArr[j].inventory_management === 'shopify' && variantsArr[j].inventory_policy === 'continue' && variantsArr[j].inventory_quantity <= 0){
            dataAvailability = true;
          }else{
            if(variantsArr[j].inventory_quantity > 0){
              dataAvailability = true;
            }else{
              dataAvailability = false;
            }
          }
          variantSearchHTML += `<li 
                class="sizeCls"
                data-availability="${dataAvailability}"
                data-variant_availability="${dataAvailability}"              
                data-var_id="${variantsArr[j].id}"
                data-pr_id="${searchDataResult.uid}"
                data-tag="${variantsArr[j].option1}"
                data-price="${(variantsArr[j].price * 100)}"
                data-buttonname="${(variantsArr[j].inventory_management == 'shopify' && variantsArr[j].inventory_policy == 'continue' && variantsArr[j].inventory_quantity <= 0) ? '<span>PRE-ORDER</span>' : '<span>ADD TO BAG</span>'}"
                data-compprice="${(variantsArr[j].compare_at_price * 100)}"
              >
                <a href="#">
                  ${typeof(variantsArr[j].mfield_custom_product_size_description_label) != 'undefined' ? variantsArr[j].mfield_custom_product_size_description_label : variantsArr[j].option1 }
                </a>
              </li>`;
        }
      }
      
      var pJpg = [360,450,520,600];           
      if(typeof(searchDataResult.images) != 'undefined'){
        var ImgInfo = searchDataResult.images.split("|")[0];
        var ImgHoverInfo = searchDataResult.images.split("|")[1];        
        if(ImgInfo != "" && typeof(ImgInfo) != "undefined"){
            var FileExt = ImgInfo.split('.').pop();        
            var arrFileDetails = ImgInfo.split('.'+FileExt);            
            var newArrFileDetails = arrFileDetails[0].split('https:');        
            var newImgSrc = '';
            if(typeof(ImgHoverInfo) != 'undefined'){
              var FileHoverExt = ImgHoverInfo.split('.').pop();
              var arrFileDetailsHover = ImgHoverInfo.split('.'+FileHoverExt);
              var newArrFileDetailsHover = arrFileDetailsHover[0].split('https:'); 
            }          
            var newHoverImgSrc = '';
            for(var j in pJpg){
                newImgSrc = newImgSrc + newArrFileDetails[1] + "_" + pJpg[j] + "x.progressive." + FileExt + " " + pJpg[j]+"w, ";
                if(typeof(ImgHoverInfo) != 'undefined'){
                  newHoverImgSrc = newHoverImgSrc + newArrFileDetailsHover[1] + "_" + pJpg[j] + "x.progressive." + FileExt + " " + pJpg[j]+"w, ";
                }
            }
        }
      }else{
        var noImgURL = `${window.location.origin}/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c`;
        var newImgSrc = '';
        var newHoverImgSrc = '';
        for(var j in pJpg){
            newImgSrc = newImgSrc + noImgURL + "_" + pJpg[j] + "x.progressive.gif.jpg" + " " + pJpg[j]+"w, ";
            if(typeof(ImgHoverInfo) != 'undefined'){
              newHoverImgSrc = newHoverImgSrc + noImgURL + "_" + pJpg[j] + "x.progressive.gif.jpg" + " " + pJpg[j]+"w, ";
            }
        }
      }
      
      var swatchCollection = "";
      var fabricTag = ``;
      var colorSwatchCount = 0;
      var notForSale = false;
      
      for (let i = 0; i < searchDataResult.tags.length; i++) {
        if (searchDataResult.tags[i].toLowerCase().startsWith('fabric-')) {
            fabricTag = searchDataResult.tags[i].split("fabric-")[1];
        }  
        if (searchDataResult.tags[i].toLowerCase().startsWith('not for sale')) {
            notForSale = true;
        }  
      }

      for (let i = 0; i < searchDataResult.collection_name.length; i++) {
        if(searchDataResult.collection_name[i].toLowerCase().startsWith("swatchgroup-")){
          swatchCollection = searchDataResult.collection_name[i].toLowerCase();
        }
      }
      
      var searchDataHTML = `
        <div class="tt-col-item" data-page=${arrSearchData['pagination']['currentPage']} data-intellisuggestData="${searchDataResult.intellisuggestData}" data-intellisuggestSignature="${searchDataResult.intellisuggestSignature}" data-elementurl="/products/${searchDataResult.handle}" data-product-id="${searchDataResult.uid}" data-default-handle="${searchDataResult.handle}">
          <div class="respimgsize tt-product product-parent options-js product-nohover">
        
            <div class="tt-image-box">
              <button data-with-epi="true" class="swym-button custom-wishlist-button swym-add-to-wishlist-view-product product_${searchDataResult.uid}" data-swaction="addToWishlist" aria-label="Add to Wishlist"  data-product-id="${searchDataResult.uid}" data-variant-id="${JSON.parse(searchDataResult.variants.replace(/&quot;/g,'"'))[0].id}" data-product-url="${window.location.origin}/products/${searchDataResult.handle}"></button>
              ${notForSale ? '' : `<div class="size-variant"></div>`}
              <a href="/products/${searchDataResult.handle}" class="img-link">
                <span class="tt-img 11">
                    <img class="lazyload" data-mainimageratio="1.0" srcset="${newImgSrc}" alt="${searchDataResult.name}">
                </span>                 
                ${newHoverImgSrc != '' ? `
                  <span class="tt-img-roll-over">
                    <img class="lazyload" srcset="${newHoverImgSrc}" alt="${searchDataResult.name}">
                  </span>
                ` : '' }                  
              </a>
            </div>
  
            <div class="tt-description">
              <div class="ptitle-price-wrap">
                  <h2 class="tt-title prod-thumb-title-color">
                      <a href="/products/${searchDataResult.handle}" class="">
                        ${("false" == 'true') ? searchDataResult.name.substring(0, "2") + '"..."' : searchDataResult.name.split("-")[0] }
                      </a>
                      <span class="selected-color current-color-${searchDataResult.uid}">${searchDataResult.variant_color}</span>
                  </h2>
                  <div class="tt-price${notForSale ? " not-for-sale" : ""}">
                    <span class="price price-${searchDataResult.uid} temp-hidden">${Shopify.formatMoney((searchDataResult.price * 100), money_format) +" "+ localizationCurrecyCode}</span>
                    <span class="old-price old-price-${searchDataResult.uid} hide temp-hidden"></span>
                  </div>
              </div>
  
              <div class="variant-fabric">
                <div class="variant-tags">
                  <div class="tt-option-block">
                    <div class="size-move-data">
                      <div class="size-position">
                        <span class="quick-add">Quick Add</span>
                        <ul class="tt-options-swatch productitem-option1-js color-opt size-ul variant-outer-${searchDataResult.uid}">${variantSearchHTML}</ul>
                      </div>
                    </div>
                    <div class="color-wrap uniqueId-${searchDataResult.uid}">
                      <span class="no_of_clr on_hover">
                        <span class="pre-colourCount-${searchDataResult.uid}"></span><span class="post-colourCount-${searchDataResult.uid}"></span>
                      </span>
                    </div>
                  </div>
                </div>
  
                ${fabricTag != "" ? `<div class="fabric-tag"><span>Fabric: </span><strong>${fabricTag}</strong></div>` : ''}
              </div>
  
              <div class="tt-product-inside-hover">
                <div class="tt-row-btn">
                  <form action="/cart/add" data-productid="${searchDataResult.uid}" method="post" enctype="multipart/form-data">
                    <input type="hidden" name="id" data-productid="${searchDataResult.uid}" value="">
                    ${searchDataResult.tags.includes("Final Sale") ? `<input type="hidden" class="finalSale" name="properties[_final_sale]" data-productid="${searchDataResult.uid}" value="Y">` : ""} 
                    <button class="tt-btn-addtocart ${ ("true" == 'true') ? 'addtocart-item-js' : ''} thumbprod-button-bg" >
                      <span>ADD TO BAG</span>
                    </button>
                  </form>
                </div>            
              </div>
            </div>
          </div>
        </div>
      `;
  
      /* Color swatch ajax on page */
      
      // if (i == 0) {         
      //   originalPrice = searchDataResult.price;
      //   jQuery.getJSON(window.Shopify.routes.root + 'products/'+ searchDataResult.handle+'.js', function(product) {        
      //     convertedPrice = product.price;
      //   });    
      // }
      
      $.ajax({
      url: `/pages/collection-colorswatch/${swatchCollection};${searchDataResult.uid};${searchDataResult.handle}`,
      type: 'GET',        
      dataType: "html",
      success: function(data) {

        data = $.parseHTML(data);
        
        var uniqueId = $(data).find('#uniqueId').html();

        $(".variant-outer-"+uniqueId+" li").each(function( index ) {
          var curVarId = $(this).attr('data-var_id');
          var newPrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .price').html();
          var newComparePrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .comp-price').html();
          $(this).attr('data-price', newPrice);
          $(this).attr('data-compprice', newComparePrice);
        });
        var colorSwatchCount = $(data).find('#swatchCount').html();          
        var preHtml = colorSwatchCount > 0 ? colorSwatchCount : "No";
        var postHtml = colorSwatchCount === 1 ? "&nbsp;color available" : "&nbsp;colors available";
        $('.pre-colourCount-' + uniqueId).html(preHtml);
        $('.post-colourCount-' + uniqueId).html(postHtml);          
        var colorSwatchBox = $(data).find('#colorSwatch-box').html();
        $('.tt-description .color-wrap.uniqueId-'+uniqueId).append(colorSwatchBox);

        var currentColor = $(data).find("#colorSwatch-box li.active a").attr("data-color");
        if(typeof(currentColor) != "undefined"){
          $('.current-color-'+uniqueId).html(currentColor);
        }

        var currentPrice = $(data).find("#productPrice").html();
        var currentCompPrice = $(data).find("#productCompPrice").html();

        if(cartCurrencySymbol != "$"){
          $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format));
          $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format));
        }else{
          $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format) +" "+ localizationCurrecyCode);
          $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format) +" "+ localizationCurrecyCode);
        }
        
        $('.tt-price .price-'+uniqueId).removeClass("temp-hidden");
        $('.tt-price .old-price-'+uniqueId).removeClass("temp-hidden");

        if(parseInt(currentCompPrice) > parseInt(currentPrice)){
           $('.tt-price .old-price-'+uniqueId).removeClass('hide');
           $('.tt-price .price-'+uniqueId).addClass('new-price');
        }          
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error("Error fetching line-item-list content:", errorThrown);
      }
    });
      
      $(".tt-product-listing").append(searchDataHTML);
    }
  
    setTimeout(() => {
      // color_update(true);
      color_swatches_function();
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    },1000);

    collectionSizeChart();
    
    /* load More Button HTML Changes start */
    var searchPaginationHTML = ``;
    var tag = '';
    var outerTag = '';
  
    if("autoscroll" == "autoscroll"){
      tag = "search_autoscroll";
      outerTag = "search_autoscroll_yes"
    }
    if($(".tt_product_showmore").length > 0){
      $(".tt_product_showmore").remove();  
    }
  
    if( typeof( arrSearchData['pagination'].nextPage) != "undefined" && arrSearchData['pagination'].nextPage > 0 ){
      searchPaginationHTML = `<div class="text-center tt_product_showmore infinitybutton ${outerTag}" style="display:block;">
          <div class="show-more">
              <a href="javascript:void(0);" class="btn btn-border ttshowmorestyle ${tag}" onClick="javascript:manageSearchPageData(${arrSearchData['pagination'].nextPage});" >Load More</a>              
          </div>
      </div>`;
    }else{
        searchPaginationHTML = `<div class="text-center tt_product_showmore infinitybutton ${outerTag}" style="display:block;">
            <div class="show-more tt_item_all_js">
              <a href="javascript:void(0);" class="btn btn-border01 ttshowmorestyle disable">NO MORE PRODUCTS</a>
            </div>
        </div>`;
    }
    $(searchPaginationHTML).insertAfter(".tt-product-listing");
  
    if( arrSearchData['page'] <= 1){
      priceFilterConvert();
    }
  }else{
  
    var apiParams = [];
    apiParams['pageRequest'] = "searchWithNoRec";
    apiParams['apiRequest'] = 'trendingProductRec';
    var trendingProductRec = 10;
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/boost/${searchSpringId}/recommend`;
    apiParams['urlParms'] = [];
    apiParams['urlParms']['tags'] = `trending-products`;
    apiParams['urlParms']['limits'] = `${trendingProductRec}`;  
    callSearchSpringAPI(apiParams);
    
    $(".search-page .no-banner-title").html(`SHOWING ${arrSearchData['pagination']['totalResults']} RESULTS${arrSearchData['q'].trim() != '' ? ' FOR "'+arrSearchData['q']+'"' : ''}.`);
    $('.title-in-line').after('<div id="zero-result-recomendation">Check out some of these popular products</div>');
    if($(".tt-title-mob.mobt-show").length > 0){
      $(".tt-title-mob.mobt-show").html(`SHOWING ${arrSearchData['pagination']['totalResults']} RESULTS${arrSearchData['q'].trim() != '' ? ' FOR "'+arrSearchData['q']+'"' : ''}.`);
    }
    $(".search-page .tt-filters-options").css("display","none");
  }
  
  if($(".product-column .title-in-line").length > 0){
    if($(".product-column .title-in-line").css("visibility") === "hidden"){
      $(".product-column .title-in-line").css("visibility","unset");
      $(".tt-title-mob.mobt-show").css("visibility","unset");      
    }
  }

  $('.tt-product-listing .tt-col-item').each(function( index ) {
    if(!$(this).hasClass("intellisuggestdata-binded-search")){
      $(this).on('click', function(){     
        var data = $(this).attr('data-intellisuggestdata');
        data = (data !== '') ? data : undefined;
        var signature = $(this).attr('data-intellisuggestsignature');
        signature = (signature !== '') ? signature : undefined;
        var elementURL = $(this).attr('data-elementurl');

        IntelliSuggest.clickItem($(this), { siteId: searchSpringId , intellisuggestData : data , intellisuggestSignature : signature, href: elementURL });
        
      });
      $(this).addClass("intellisuggestdata-binded-search");
    }
  });
}
/* ==============  Function for search Page data after get responce of SearchSpringAPI end   ============== */

/* ==============  Function for search Page data after get 0 record of SearchSpringAPI Start   ============== */
function manageTrendingSearchData(arrSearchProdData){  
  if(arrSearchProdData['ProductResults'].length > 0){  
    for (let i = 0; i <+ arrSearchProdData['ProductResults'].length; i++) {
      var searchDataResult = arrSearchProdData['ProductResults'][i];      
      var variantSearchHTML = '';
      if(typeof(searchDataResult.attributes.variants) != "undefined"){
        var variantsArr = JSON.parse(searchDataResult.attributes.variants.replace(/&quot;/g,'"'));
        for (var j = 0; j < variantsArr.length; j++) {
          var dataAvailability = false;
          if(geoLocationCode != "US" && searchDataResult.attributes.tags.includes("Global-e Restricted")){
            dataAvailability = false;
          }else if(variantsArr[j].inventory_management === 'shopify' && variantsArr[j].inventory_policy === 'continue' && variantsArr[j].inventory_quantity <= 0){
            dataAvailability = true;
          }else{
            if(variantsArr[j].inventory_quantity > 0){
              dataAvailability = true;
            }else{
              dataAvailability = false;
            }
          }
          variantSearchHTML += `<li 
                class="sizeCls"
                data-availability="${dataAvailability}"
                data-variant_availability="${dataAvailability}"              
                data-var_id="${variantsArr[j].id}"
                data-pr_id="${searchDataResult.mappings.core.uid}"
                data-tag="${variantsArr[j].option1}"
                data-price="${(variantsArr[j].price * 100)}"
                data-buttonname="${(variantsArr[j].inventory_management == 'shopify' && variantsArr[j].inventory_policy == 'continue' && variantsArr[j].inventory_quantity <= 0) ? '<span>PRE-ORDER</span>' : '<span>ADD TO BAG</span>'}"
                data-compprice="${(variantsArr[j].compare_at_price * 100)}"
              >
                <a href="#">
                  ${typeof(variantsArr[j].mfield_custom_product_size_description_label) != 'undefined' ? variantsArr[j].mfield_custom_product_size_description_label : variantsArr[j].option1 }
                </a>
              </li>`;
        }
      }
      
      var pJpg = [360,450,520,600];           
      if(typeof(searchDataResult.mappings.core.imageUrl) != 'undefined'){
        var ImgInfo = searchDataResult.attributes.images.split("|")[0];
        var ImgHoverInfo = searchDataResult.attributes.images.split("|")[1]        
        if(ImgInfo != "" && typeof(ImgInfo) != "undefined"){
            var FileExt = ImgInfo.split('.').pop();        
            var arrFileDetails = ImgInfo.split('.'+FileExt);            
            var newArrFileDetails = arrFileDetails[0].split('https:');        
            var newImgSrc = '';
            if(typeof(ImgHoverInfo) != 'undefined'){
              var FileHoverExt = ImgHoverInfo.split('.').pop();
              var arrFileDetailsHover = ImgHoverInfo.split('.'+FileHoverExt);
              var newArrFileDetailsHover = arrFileDetailsHover[0].split('https:'); 
            }          
            var newHoverImgSrc = '';
            for(var j in pJpg){
                newImgSrc = newImgSrc + newArrFileDetails[1] + "_" + pJpg[j] + "x.progressive." + FileExt + " " + pJpg[j]+"w, ";
                if(typeof(ImgHoverInfo) != 'undefined'){
                  newHoverImgSrc = newHoverImgSrc + newArrFileDetailsHover[1] + "_" + pJpg[j] + "x.progressive." + FileExt + " " + pJpg[j]+"w, ";
                }
            }
        }
      }else{
        var noImgURL = `${window.location.origin}/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c`;
        var newImgSrc = '';
        var newHoverImgSrc = '';
        for(var j in pJpg){
            newImgSrc = newImgSrc + noImgURL + "_" + pJpg[j] + "x.progressive.gif.jpg" + " " + pJpg[j]+"w, ";
            if(typeof(ImgHoverInfo) != 'undefined'){
              newHoverImgSrc = newHoverImgSrc + noImgURL + "_" + pJpg[j] + "x.progressive.gif.jpg" + " " + pJpg[j]+"w, ";
            }
        }
      }

      var swatchCollection = "";
      var fabricTag = ``;
      var colorSwatchCount = 0;
      var notForSale = false;      
      for (let i = 0; i < searchDataResult.attributes.tags.length; i++) {
        if (searchDataResult.attributes.tags[i].toLowerCase().startsWith('fabric-')) {
            fabricTag = searchDataResult.attributes.tags[i].split("fabric-")[1];
        }

        if (searchDataResult.attributes.tags[i].toLowerCase().startsWith('not for sale')) {
            notForSale = true;
        }
      }

      for (let i = 0; i < searchDataResult.attributes.collection_name.length; i++) {
        if(searchDataResult.attributes.collection_name[i].toLowerCase().startsWith("swatchgroup-")){
          swatchCollection = searchDataResult.attributes.collection_name[i].toLowerCase();
        }
      }
      
      var searchDataHTML = `
        <div class="tt-col-item" data-page="1" data-product-id="${searchDataResult.mappings.core.uid}" data-default-handle="${searchDataResult.mappings.core.url}">
          <div class="respimgsize tt-product product-parent options-js product-nohover">
        
            <div class="tt-image-box">
              <button data-with-epi="true" class="swym-button custom-wishlist-button swym-add-to-wishlist-view-product product_${searchDataResult.uid}" data-swaction="addToWishlist" aria-label="Add to Wishlist"  data-product-id="${searchDataResult.uid}" data-variant-id="${JSON.parse(searchDataResult.attributes.variants.replace(/&quot;/g,'"'))[0].id}" data-product-url="${window.location.origin}/products/${searchDataResult.mappings.core.url}"></button>
              ${notForSale ? '' : `<div class="size-variant"></div>`}
              <a href="/products/${searchDataResult.mappings.core.url}" class="img-link">
                <span class="tt-img 11">
                    <img class="lazyload" data-mainimageratio="1.0" srcset="${newImgSrc}" alt="${searchDataResult.name}">
                </span>                 
                ${newHoverImgSrc != '' ? `
                  <span class="tt-img-roll-over">
                    <img class="lazyload" srcset="${newHoverImgSrc}" alt="${searchDataResult.mappings.core.name}">
                  </span>
                ` : '' }                  
              </a>
            </div>
  
            <div class="tt-description">
              <div class="ptitle-price-wrap">
                  <h2 class="tt-title prod-thumb-title-color">
                      <a href="/products/${searchDataResult.mappings.core.url}" class="">
                        ${("false" == 'true') ? searchDataResult.mappings.core.name.substring(0, "2") + '"..."' : searchDataResult.mappings.core.name.split("-")[0] }
                      </a>
                      <span class="selected-color current-color-${searchDataResult.mappings.core.uid}">${searchDataResult.mappings.core.name.split("-")[1]}</span>
                  </h2>
                  <div class="tt-price${notForSale ? " not-for-sale" : ""}">
                    <span class="price price-${searchDataResult.mappings.core.uid}">${Shopify.formatMoney((searchDataResult.mappings.core.price * 100), money_format) +" "+ localizationCurrecyCode}</span>
                    <span class="old-price old-price-${searchDataResult.mappings.core.uid} hide"></span>
                  </div>
              </div>
  
              <div class="variant-fabric">
                <div class="variant-tags">
                  <div class="tt-option-block">
                    <div class="size-move-data">
                      <div class="size-position">
                        <span class="quick-add">Quick Add</span>
                        <ul class="tt-options-swatch productitem-option1-js color-opt size-ul variant-outer-${searchDataResult.mappings.core.uid}">${variantSearchHTML}</ul>
                      </div>
                    </div>
                    <div class="color-wrap uniqueId-${searchDataResult.mappings.core.uid}">
                      <span class="no_of_clr on_hover">
                        <span class="pre-colourCount-${searchDataResult.mappings.core.uid}"></span><span class="post-colourCount-${searchDataResult.mappings.core.uid}"></span>
                      </span>
                    </div>
                  </div>
                </div>
  
                ${fabricTag != "" ? `<div class="fabric-tag"><span>Fabric: </span><strong>${fabricTag}</strong></div>` : ''}
              </div>
  
              <div class="tt-product-inside-hover">
                <div class="tt-row-btn">
                  <form action="/cart/add" data-productid="${searchDataResult.mappings.core.uid}" method="post" enctype="multipart/form-data">
                    <input type="hidden" name="id" data-productid="${searchDataResult.uid}" value="">
                    ${searchDataResult.attributes.tags.includes("Final Sale") ? `<input type="hidden" class="finalSale" name="properties[_final_sale]" data-productid="${searchDataResult.uid}" value="Y">` : ""} 
                    <button class="tt-btn-addtocart ${ ("true" == 'true') ? 'addtocart-item-js' : ''} thumbprod-button-bg" >
                      <span>ADD TO BAG</span>
                    </button>
                  </form>
                </div>            
              </div>
            </div>
          </div>
        </div>
      `;
  
      /* Color swatch ajax on page */
      
      if (i == 0) {
        originalPrice = searchDataResult.mappings.core.price;
        jQuery.getJSON(window.Shopify.routes.root + 'products/'+ searchDataResult.mappings.core.url+'.js', function(product) {        
          convertedPrice = product.price;
        });    
      }
      $.ajax({
        url: `/pages/collection-colorswatch/${swatchCollection};${searchDataResult.mappings.core.uid};${searchDataResult.mappings.core.url}`,
        type: 'GET',        
        success: function(data) {
          var uniqueId = $(data).find('#uniqueId').html();
          $(".variant-outer-"+uniqueId+" li").each(function( index ) {
            var curVarId = $(this).attr('data-var_id');
            var newPrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .price').html();
            var newComparePrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .comp-price').html();
            $(this).attr('data-price', newPrice);
            $(this).attr('data-compprice', newComparePrice);
          });
          var colorSwatchCount = $(data).find('#swatchCount').html();          
          var preHtml = colorSwatchCount > 0 ? colorSwatchCount : "No";
          var postHtml = colorSwatchCount === 1 ? "&nbsp;color available" : "&nbsp;colors available";
          $('.pre-colourCount-' + uniqueId).html(preHtml);
          $('.post-colourCount-' + uniqueId).html(postHtml);          
          var colorSwatchBox = $(data).find('#colorSwatch-box').html();        
          $('.tt-description .color-wrap.uniqueId-'+uniqueId).append(colorSwatchBox);
  
          var currentColor = $(data).find("#colorSwatch-box li.active a").attr("data-color");
          $('.current-color-'+uniqueId).html(currentColor);
  
          var currentPrice = $(data).find("#productPrice").html();
          var currentCompPrice = $(data).find("#productCompPrice").html();

          if(cartCurrencySymbol != "$"){
            $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format));
            $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format));
          }else{
            $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format) +" "+ localizationCurrecyCode);  
            $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format) +" "+ localizationCurrecyCode);
          }
     
          if(parseInt(currentCompPrice) > parseInt(currentPrice)){
             $('.tt-price .old-price-'+uniqueId).removeClass('hide');
             $('.tt-price .price-'+uniqueId).addClass('new-price');
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error fetching line-item-list content:", errorThrown);
        }
      });      
      $(".tt-product-listing").append(searchDataHTML);
    }

    setTimeout(() => {
      // color_update(true);
      color_swatches_function();
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    },1000);
    collectionSizeChart();
  }  
}
/* ==============  Function for search Page data after get 0 record of SearchSpringAPI end   ============== */


/* ==============  Function for call SearchSpringAPI start   ============== */
function callSearchSpringAPI( arrApiParams ){
    var url = arrApiParams['baseURL'];
    var ajaxResponse = [];     
    var queryParamsURL = '';   
    for (var key in arrApiParams['urlParms']) {
      if (queryParamsURL != "") {
        queryParamsURL += "&";
      }
      if(typeof(arrApiParams['urlParms'][key]) == 'object'){
        for ( var valueKey in arrApiParams['urlParms'][key] ){          
          if (queryParamsURL != "" && queryParamsURL.charAt(queryParamsURL.length - 1) != "&") {
            queryParamsURL += "&";
          }
          queryParamsURL += key + "=" + encodeURIComponent(arrApiParams['urlParms'][key][valueKey]);          
        }
      }else{
        queryParamsURL += key + "=" + encodeURIComponent(arrApiParams['urlParms'][key]);
      }      
    }    
    var searchSpringAPIURL = url+"?"+queryParamsURL;
  
    if( false ){
      console.log("New arrApiParams:", arrApiParams);
      console.log("url", url);
      console.log("queryParamsURL", queryParamsURL);
      console.log("searchSpringAPIURL", searchSpringAPIURL);
      console.log("featureProductParams", arrApiParams['featureProductParams']);
    }  
    var asyncParam = true;
    if(typeof(arrApiParams['featureProductParams']) != "undefined" && arrApiParams['featureProductParams'] == "Y" && arrApiParams['page'] <= 1){
      asyncParam = false;
    }else{
      asyncParam = true;
    }  
    var settings = {
      async: asyncParam,
      crossDomain: true,
      url: searchSpringAPIURL,
      method: 'GET',
      headers: {
        accept: 'application/json'
      }
    };

    $.ajax(settings).done(function (response) {

       /* check and redirect if redirection is set or not for search query - start */
        
        if( ( arrApiParams['pageRequest'] != "common" && page_template == 'page.search-result-searchspring' && typeof(response.merchandising) != "undefined" ) && (typeof(response.merchandising.redirect) != "undefined" && response.merchandising.redirect != "") ) {
           window.location.href = response.merchandising.redirect;
           return false;
        }
      
        /* check and redirect if redirection is set or not for search query - end */

      if(typeof(arrApiParams['featureProductParams']) != "undefined" && response.results.length > 0 && arrApiParams['featureProductParams'] == "Y" && arrApiParams['page'] <= 1 && featuredProductHandle.includes(response?.results?.[0]?.handle)){
         featuredProductArr = [];          
      }
      
      if(typeof(arrApiParams['featureProductParams']) != "undefined" && arrApiParams['featureProductParams'] == "Y" && response.results.length <= 0 && arrApiParams['page'] <= 1){
         featuredProductArr = [];
      }

      var flag = false;
      if(arrApiParams['pageRequest'] == "collection"){
        if(response.results.length > 0){
           flag = true;
        }
      }else{
        flag = true;
      }
      
      if(typeof(arrApiParams['featureProductParams']) != "undefined" && arrApiParams['featureProductParams'] == "Y" && arrApiParams['pageRequest'] == "collection" && response.results.length > 0 && featuredProductHandle.includes(response?.results?.[0]?.handle) && ((response.results.length == featuredProductHandle.length) ||  featuredProductHandle.length > 0) && arrApiParams['page'] <= 1){
        featuredProductArr = [];
        featuredProductArrRes = response.results;
        if(featuredProductHandle.length > 1){
          featuredProductHandle.forEach(ProductHandle => {
              featuredProductArrRes.forEach(featuredProduct => {
                  if(featuredProduct.handle == ProductHandle){
                    featuredProductArr.push(featuredProduct);
                  }
              });
          });
        }else{
          featuredProductArr = featuredProductArrRes
        }
        
        featuredProductArr = featuredProductArr.filter((item, index, self) =>
            index === self.findIndex(t => t.handle === item.handle)
        );        
      }else if(flag){
        switch(arrApiParams['pageRequest']) {
        case "collection" :            
            /* Process Collection Page Data  */
            var arrCollectionData = [];
            var newResponseResultArr = [];
            
            if(featuredProductArr.length > 0 && arrApiParams['page'] <= 1){              
              var filteredResultsTemp = response.results.filter(result => 
                  !featuredProductArr.some(featured => featured.handle === result.handle)
              );
              newResponseResultArr = featuredProductArr.concat(filteredResultsTemp);
            }else{
              var filteredResultsTemp = response.results.filter(result => 
                  !featuredProductArr.some(featured => featured.handle === result.handle)
              );
              newResponseResultArr = filteredResultsTemp;
            }
            arrCollectionData['page'] = response.pagination.currentPage;
            arrCollectionData['feturedProductResponse'] = "N";
            /*  response.singleResult for the featured product response */                      
            if( typeof(response.singleResult) != "undefined" && featuredProductHandle.includes(response.singleResult) ){
                arrCollectionData['feturedProductResponse'] = "Y";
                if( typeof(response.results) != "undefined" && response.results.length > 0 ) {
                    arrCollectionData['collectionProductResults'] = response.results;
                }
                if( typeof(response.pagination) != "undefined" ) {
                    arrCollectionData['pagination'] = response.pagination;
                }
            } else{
                if( typeof(newResponseResultArr) != "undefined" && newResponseResultArr.length > 0 ) {
                    arrCollectionData['collectionProductResults'] = newResponseResultArr;
                }
                if( typeof(response.pagination) != "undefined" ) {
                    arrCollectionData['pagination'] = response.pagination;
                }
                if( typeof(response.sorting.options) != "undefined" && response.sorting.options.length > 0 ) {
                    arrCollectionData['sorting'] = response.sorting;
                }
                if( typeof(response.facets) != "undefined" && response.facets.length > 0 ) {
                    arrCollectionData['facets'] = response.facets;
                }                
            }            
            /* Process Products Data */    
            manageProductData(arrCollectionData);
        break;
          
        case "product":          
          var arrProductData = [];
          arrProductData['ProductResults'] = response[0].results;
          manageProductPageData(arrProductData);
        break;

        case "page.search-result-searchspring":
          var arrSearchData = []; 
          arrSearchData['page'] = response.pagination.currentPage;
          if( typeof(response.results) != "undefined" && response.results.length > 0 ) {
              arrSearchData['searchProductResults'] = response.results;
          }
          if( typeof(response.pagination) != "undefined" ) {
              arrSearchData['pagination'] = response.pagination;
          }
          if( typeof(response.sorting.options) != "undefined" && response.sorting.options.length > 0 ) {
              arrSearchData['sorting'] = response.sorting;
          }
          if( typeof(response.facets) != "undefined" && response.facets.length > 0 ) {
              arrSearchData['facets'] = response.facets;
          }
          if( typeof(arrApiParams['urlParms']['q']) != "undefined" ){
             arrSearchData['q'] = arrApiParams['urlParms']['q'];
          }
          manageSearchData(arrSearchData);
        break;

        case "searchWithNoRec" :
          var arrSearchWithNoRecData = [];
          arrSearchWithNoRecData['ProductResults'] = response[0].results;
          manageTrendingSearchData(arrSearchWithNoRecData);          
        break;
          
        case "common" :
          var arrCommonnData = [];          
          if(arrApiParams['apiRequest'] == 'trending'){
            arrCommonnData['apiRequestData'] = arrApiParams['apiRequest'];
            arrCommonnData['responseResultData'] = response;
          }
          if(arrApiParams['apiRequest'] == 'trendingProductRec'){
            arrCommonnData['apiRequestData'] = arrApiParams['apiRequest'];
            arrCommonnData['responseResultData'] = response;
          }          
          if(arrApiParams['apiRequest'] == 'suggestApi'){
            arrCommonnData['apiRequestData'] = arrApiParams['apiRequest'];
            arrCommonnData['apiRequestInput'] = arrApiParams['urlParms']['q'];
            arrCommonnData['responseResultData'] = response;
          }
          if(arrApiParams['apiRequest'] == 'searchResult'){
            arrCommonnData['apiRequestData'] = arrApiParams['apiRequest'];
            arrCommonnData['apiRequestInput'] = arrApiParams['urlParms']['q'];
            arrCommonnData['responseResultData'] = response;
          }          
          manageCommonData(arrCommonnData);
        break;
      }
      }
    });
}
/* ==============  Function for call SearchSpringAPI end   ============== */


/* ==============  Function for onScroll api for SearchSpringAPI start   ============== */
myInterval = setInterval(function () {  
  if($('.autoscroll_yes').length > 0){
    clearInterval(myInterval);
    $(window).scroll(function(){
      autoscrollhandler();
    });
  }
}, 1000);

function autoscrollhandler(){
  var _as = $('.autoscroll');
  if(_as.length == 0) return false;
  var contY = parseInt(_as.parent().offset().top);
  var wY = getWindowHeight()+getWindowTopY();  
  if( contY <= wY ) {
    _as.removeClass('autoscroll').trigger('click');
  }
}
/* ==============  Function for onScroll api for SearchSpringAPI end   ============== */


/* ==============  SearchSpring Common API Function start   ============== */

function trendingSearchResultAPI(){
  var apiParams = [];
  var trendinglimit = 5;
  apiParams['pageRequest'] = 'common';
  apiParams['apiRequest'] = 'trending';
  apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/suggest/trending`;
  apiParams['urlParms'] = [];
  apiParams['urlParms']['siteId'] = `${searchSpringId}`;
  apiParams['urlParms']['limit'] = `${trendinglimit}`;  
  callSearchSpringAPI(apiParams);
}

function trendingSearchProductResultAPI(){
  var apiParams = [];
  apiParams['pageRequest'] = 'common';
  apiParams['apiRequest'] = 'trendingProductRec';
  var trendingProductRec = 3;
  apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/boost/${searchSpringId}/recommend`;
  apiParams['urlParms'] = [];
  apiParams['urlParms']['tags'] = `trending-products`;
  apiParams['urlParms']['limits'] = `${trendingProductRec}`;  
  callSearchSpringAPI(apiParams);
}

function SearchSuggestionsResultAPI(element){
  if(element.value.trim().length > 0){
    var apiParams = [];
    var suggestionCount = 6;
    apiParams['pageRequest'] = 'common';
    apiParams['apiRequest'] = 'suggestApi';
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/suggest/query`;
    apiParams['urlParms'] = [];
    apiParams['urlParms']['siteId'] = `${searchSpringId}`;    
    apiParams['urlParms']['q'] = element.value;
    apiParams['urlParms']['bgfilter.ss_is_published'] = 1;
    apiParams['urlParms']['bgfilter.ss_visibility'] = "search";
    apiParams['urlParms']['suggestionCount'] = `${suggestionCount}`;    
    callSearchSpringAPI(apiParams);
  }else{
      $(".search-seggestion-outer .viewAll-search").html('View All Results').attr("href", `/pages/${searchPageRedirection}?q=`);
      $(".search-seggestion-outer .searchGrid-left .grid-title").html('Trending searches');
      $(".search-seggestion-outer .searchGrid-right .grid-title").html('Trending products');      
      $(".search-seggestion-outer .search-navList.search-suggest").css('display','none');
      $(".search-seggestion-outer .search-navList.trending-search").css('display','block');
      $(".search-seggestion-outer .searchGrid-right .search-product--items.search-products").css('display','none');
      $(".search-seggestion-outer .searchGrid-right .search-product--items.search-trending-product").css('display','block');
      $(".mobile-search-suggest-outer .mobile-search-inner.mobile-search-inner-trending").css('display','block');
      $(".mobile-search-suggest-outer .mobile-search-inner.mobile-search-inner-suggestion").css('display','none');
  }
  if(!$(".bg-opacity .tt-search-opened-headtype1 form .search-seggestion-outer").is(":visible") && !suggestApiFlagNoRes && !searchResultFlagNoRes){
    $("#tt-search-input").click();
  }  
}

function SearchSuggestionsProductResultAPI(element){
  if(element.value.trim().length > 0){
    var apiParams = [];
    var resultPerPageCount = 3;
    apiParams['pageRequest'] = 'common';
    apiParams['apiRequest'] = 'searchResult';
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/search/autocomplete.json`;
    apiParams['urlParms'] = [];
    apiParams['urlParms']['siteId'] = `${searchSpringId}`;    
    apiParams['urlParms']['q'] = element.value;
    apiParams['urlParms']['resultsFormat'] = 'json';
    apiParams['urlParms']['bgfilter.ss_is_published'] = 1;
    apiParams['urlParms']['bgfilter.ss_visibility'] = "search";
    apiParams['urlParms']['resultsPerPage'] = `${resultPerPageCount}`;    
    callSearchSpringAPI(apiParams);
  }else{
    $(".search-seggestion-outer .viewAll-search").html('View All Results').attr("href", `/pages/${searchPageRedirection}?q=`);      
    $(".search-seggestion-outer .searchGrid-left .grid-title").html('Trending searches');
    $(".search-seggestion-outer .searchGrid-right .grid-title").html('Trending products');    
    $(".search-seggestion-outer .search-navList.search-suggest").css('display','none');
    $(".search-seggestion-outer .search-navList.trending-search").css('display','block');
    $(".search-seggestion-outer .searchGrid-right .search-product--items.search-products").css('display','none');
    $(".search-seggestion-outer .searchGrid-right .search-product--items.search-trending-product").css('display','block');
  }
}

function callSearchSpringCommonAPI(){
  var inputElement = document.getElementById("tt-search-input");
  var inputElementMob = document.getElementById("tt-search-input-mob");
  if ($(".tt-mobile-header").css("display") !== "none") {
    trendingSearchResultAPI();
    
    inputElementMob.addEventListener("keyup", function(event) {
      var serchTxt = $("#tt-search-input").val();
      $(".search-seggestion-outer .viewAll-search").html('View All Results for <b><u>'+serchTxt+ '</u></b>').attr("href", `/pages/${searchPageRedirection}?q=${serchTxt}`);
      
      setTimeout(function(){
        SearchSuggestionsResultAPI(inputElementMob);
      }, 5);
    });
    
    if(document.getElementById("tt-search-input-mob").value != ""){
        SearchSuggestionsResultAPI(inputElement);        
    }
  }else{
    trendingSearchResultAPI();
    trendingSearchProductResultAPI();    
    
    inputElement.addEventListener("keyup", function(event) {

      var serchTxt = $("#tt-search-input").val();
      $(".search-seggestion-outer .viewAll-search").html('View All Results for <b><u>'+serchTxt+ '</u></b>').attr("href", `/pages/${searchPageRedirection}?q=${serchTxt}`);
      
      setTimeout(function(){
        SearchSuggestionsResultAPI(inputElement);
        SearchSuggestionsProductResultAPI(inputElement);
      }, 5);
    });

    if(document.getElementById("tt-search-input").value != ""){
        SearchSuggestionsResultAPI(inputElement);
        SearchSuggestionsProductResultAPI(inputElement);
    }
  }

  if($(".tt-mobile-parent-search .tt-dropdown-toggle").length > 0){
  	$(".tt-mobile-parent-search .tt-dropdown-toggle").on("click", function() {
  		if($(".mobile-search-suggest-outer").is(":visible")){
  			$(".mobile-search-suggest-outer").css("display","none");
  		}
  	});
  }

  if($(".tt-mobile-parent-search .tt-dropdown-menu .tt-search-input").length > 0){
    $(".tt-mobile-parent-search .tt-dropdown-menu .tt-search-input").on("click", function() {
  		if(!$(".mobile-search-suggest-outer").is(":visible")){
  			$(".mobile-search-suggest-outer").css("display","block");
  		}
  	});
  }
}

/* ==============  SearchSpring Common API Function end   ============== */




/* ==============  SearchSpring product Beacon API Function Start   ============== */
function callSearchSpringBeaconAPI(beaconParams){
    $.ajax({
      url: 'https://beacon.searchspring.io/beacon',
      method: 'POST',
      headers: {
          accept: 'application/json',
          'content-type': 'application/json'
      },
      data: JSON.stringify(beaconParams),
      success: function(response) {        
        console.log(response);
      },
      error: function(err) {
          console.error(err);
      }
    });
}

function callBeaconApiForProductRender(arrProductProfile){ 
  let arrayOfObjectsForProducts = [];
  let randomID = self.crypto.randomUUID();
  let pageLoadSearchID = self.crypto.randomUUID();
  /* object for profile render */
  let objProfileRender = {
      "category": "searchspring.recommendations.user-interactions",
      "context": {
          "sessionCookie": ssSessionIdNamespaceCookie,
          "userId": ssUserIdCookie,
          "pageLoadId": pageLoadSearchID,
          "website": {
              "trackingCode": searchSpringId
          }
      },
      "type": "profile.render",
      "id": randomID,
      "event": {
          "context": {
              "type": "product-recommendation",
              "tag": "similar",
              "placement": "product-page"
          },
          "profile": {
              "tag": "similar",
              "placement": "product-page",
              "seed": []
          }
      }
  }

  arrayOfObjectsForProducts.push(objProfileRender);

  var baseApiObj  = {
      "category": "searchspring.recommendations.user-interactions",
      "context": {
          "sessionCookie": ssSessionIdNamespaceCookie,
          "userId": ssUserIdCookie,          
          "website": {
              "trackingCode": searchSpringId
          }
      },
      "type": "profile.product.render",  
      "event": {
          "context": {
              "type": "product-recommendation",
              "tag": "similar",
              "placement": "product-page"
          },
          "product": {             
              "seed": []
          }
      }
  }

  arrProductProfile['ProductResults'].forEach(productResult => {      
      const productObject = JSON.parse(JSON.stringify(baseApiObj));

      const tempPageLoadId = self.crypto.randomUUID();
      const tempId = self.crypto.randomUUID();
            
      productObject.event.product.id = productResult.id;
      productObject.event.product.mappings = productResult.mappings;
            
      productObject.context.pageLoadId = tempPageLoadId;
      productObject.id = tempId;
    
      arrayOfObjectsForProducts.push(productObject);
  });

  callSearchSpringBeaconAPI(arrayOfObjectsForProducts);
  
}
/* ==============  SearchSpring product Beacon API Function End   ============== */




/* ==============  Search Spring required Cookie generation Start   ============== */
manageSearchSpringCookie();
/* ==============  Search Spring required Cookie generation end   ============== */

/* set common Constant for searchspring start  */
var searchSpringId = "jkgnc5";
const resultPerPage = 25;
var currentDomain = window.location.pathname+location.search;
var page_template = pageTemplate;
var hasFeaturedProduct = false;
var featuredProductHandle = [];
var ssUserIdCookie = getSearchSpringCookie('ssUserId');
var ssSessionIdNamespaceCookie = getSearchSpringCookie('ssSessionIdNamespace');

var currentSiteURL = `${window.location.origin}${window.location.pathname}${location.search}`;

var getSearchParams = getFilterParams(currentSiteURL);
if(getSearchParams.featuredURL != ''){
  var featuredURLParams = getSearchParams.featuredURL.split('featured=')[1];
  featuredProductHandle = featuredURLParams.split(',');    
}
/* set common Constant for searchspring end  */
switch(page_template) {
  case "collection":
    /* Get Collection Touts Information if avaialble */
    var collectionToutResult = getCollectionTouts();
    var collectionTouteDeskResult = collectionToutResult.promoHTMLParse;
    var collectionTouteMobResult = collectionToutResult.promoHTMLParse_Mob;
    var collectionParam = [];
    var currentPage = 1;
    var featuredProductResponse = [];
    var arrCollectionData = []; 
    var pageLoad = self.crypto.randomUUID();
    var apiParams = [];
   
    apiParams['pageRequest'] = page_template;
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/search/search.json`; 
    apiParams['urlParms'] = [];
    apiParams['urlParms']['siteId'] = `${searchSpringId}`;   
    apiParams['urlParms']['page'] = `${currentPage}`; 
    apiParams['urlParms']['resultsFormat'] = "json";     
    apiParams['urlParms']['resultsPerPage'] = `${resultPerPage}`;     
    apiParams['urlParms']['userId'] = `${ssUserIdCookie}`; 
    apiParams['urlParms']['sessionId'] = `${ssSessionIdNamespaceCookie}`; 
    apiParams['urlParms']['domain'] = `${currentDomain}`; 
    apiParams['urlParms']['pageLoadId'] = `${pageLoad}`; 
    apiParams['urlParms']['bgfilter.ss_is_published'] = 1;
    /* Check current Window URL & Set Parameter Start */
    const currentURL = `${window.location.origin}${window.location.pathname}${location.search}`;
    const getSearchParams = getFilterParams(currentURL);
	
	var sortingOption = (getSearchParams.sortURL != "" ? getSearchParams.sortURL : "");
    var filterOption = (getSearchParams.filterURL != "" ? getSearchParams.filterURL : "");

    if( filterOption != "" ){
      var arrFilterSplt = filterOption.split('&');
      for (var i = 0; i < arrFilterSplt.length; i++) {
          var arrFilterValues = arrFilterSplt[i].split("=");                
          if (apiParams['urlParms'][arrFilterValues[0]]) {
              apiParams['urlParms'][arrFilterValues[0]].push(arrFilterValues[1]);
          } else {
              apiParams['urlParms'][arrFilterValues[0]] = [arrFilterValues[1]];
          }
      }
    }
    
    if( sortingOption != "" ){
      var arrSortingSplt = sortingOption.split('&');
      for( var sptKey in  arrSortingSplt ){
        var sortngStr = arrSortingSplt[sptKey];
        var arrSoringValues = sortngStr.split("=");
        apiParams['urlParms'][arrSoringValues[0]] = arrSoringValues[1];
      }
    } 
	
    /* Check cuurent Window URL & Set Parameter End */    
    /* featured pinned product logic Start  */    
    if ( featuredProductHandle.length > 0 ){
        hasFeaturedProduct = true;
        apiParams['page'] = currentPage;
        for (let h = 0; h < featuredProductHandle.length; h++) {
        	if (apiParams['urlParms']["bgfilter.handle"]) {
        		apiParams['urlParms']["bgfilter.handle"].push(featuredProductHandle[h]);
        	} else {
        		apiParams['urlParms']["bgfilter.handle"] = [featuredProductHandle[h]];
        	}
        }
        apiParams['urlParms']["featureProduct"]  = "Y";
        apiParams['featureProductParams'] = "Y";
        callSearchSpringAPI(apiParams);
        // for (let h = 0; h <+ featuredProductHandle.length; h++) {
        //   apiParams['urlParms']["bgfilter.handle"]  = featuredProductHandle[h];
        //   apiParams['urlParms']["featureProduct"]  = "Y";          
        //   /* Call searchspring API for fetured product result */
        //   // callSearchSpringAPI(apiParams);
        // }
    }    
    /* Call SeacgSpring API to get collection result */
    delete apiParams['urlParms']["bgfilter.handle"];
    apiParams['urlParms']["featureProduct"] = "N";
    apiParams['featureProductParams'] = "N";
    apiParams['urlParms']["bgfilter.collection_id"]  = currentCollectionId;    
    
    apiParams['page'] = currentPage;
       
    /* Get result for collection product */
    callSearchSpringAPI(apiParams);
    callSearchSpringCommonAPI();
  break;
  
  case "searchspring-seach":
  break;

  case "page.search-result-searchspring":    
    let params = new URLSearchParams(document.location.search);
    let searchTerms = params.get("q");
    let currentSearchPage = 1;
    let resultPerSearchPage = 20;
    let pageLoadSearch = self.crypto.randomUUID();
    var apiParams = [];   
    apiParams['pageRequest'] = page_template;
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/search/search.json`; 
    apiParams['urlParms'] = [];
    apiParams['urlParms']['siteId'] = `${searchSpringId}`;
    apiParams['urlParms']['q'] = `${searchTerms}`;
    apiParams['urlParms']['bgfilter.ss_is_published'] = 1;
    apiParams['urlParms']['bgfilter.ss_visibility'] = "search";
    apiParams['urlParms']['page'] = `${currentSearchPage}`; 
    apiParams['urlParms']['resultsFormat'] = "json";
    apiParams['urlParms']['resultsPerPage'] = `${resultPerSearchPage}`;     
    apiParams['urlParms']['userId'] = `${ssUserIdCookie}`; 
    apiParams['urlParms']['sessionId'] = `${ssSessionIdNamespaceCookie}`; 
    apiParams['urlParms']['domain'] = `${currentDomain}`; 
    apiParams['urlParms']['pageLoadId'] = `${pageLoadSearch}`;
    if(arrFilterRemoveSearch.length > 0){
       apiParams['urlParms']['excludedFacets'] = arrFilterRemoveSearch;
    }

    if($(".tt-search-input").length > 0){
      $(".tt-search-input").val(searchTerms);      
    }

    /* Check if current URL contains any params or not */
    /* Check current Window URL & Set Parameter Start */
    const currentURLSearchDefault = `${window.location.origin}${window.location.pathname}${location.search}`;
    const getSearchParamsSearchDefault = getFilterParams(currentURLSearchDefault);
  
    var sortingOptionSearch = (getSearchParamsSearchDefault.sortURL != "" ? getSearchParamsSearchDefault.sortURL : "");
    var filterOptionSearch = (getSearchParamsSearchDefault.filterURL != "" ? getSearchParamsSearchDefault.filterURL : "");
    
    if( filterOptionSearch != "" ){
        var arrFilterSplt = filterOptionSearch.split('&');
        for (var i = 0; i < arrFilterSplt.length; i++) {
            var arrFilterValues = arrFilterSplt[i].split("=");                
            if (apiParams['urlParms'][arrFilterValues[0]]) {
                apiParams['urlParms'][arrFilterValues[0]].push(arrFilterValues[1]);
            } else {
                apiParams['urlParms'][arrFilterValues[0]] = [arrFilterValues[1]];
            }
        }                
    }
    if( sortingOptionSearch != "" ){
        var arrSortingSpltSearch = sortingOptionSearch.split('&');
        for( var sptKey in  arrSortingSpltSearch ){
            var sortngStr = arrSortingSpltSearch[sptKey];
            var arrSoringValues = sortngStr.split("=");
            apiParams['urlParms'][arrSoringValues[0]] = arrSoringValues[1];
        }
    }

    callSearchSpringAPI(apiParams);
    callSearchSpringCommonAPI();
  break;
  
  case "product":
    var apiParams = [];
    var pageLoadedId = self.crypto.randomUUID();
    var currentProductId = `$(this).parents('div[class^="tt-col-item']").attr('data-product-id')`;
    apiParams['pageRequest'] = page_template;
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/boost/${searchSpringId}/recommend`; 
    apiParams['urlParms'] = [];
    apiParams['urlParms']['siteId'] = `${searchSpringId}`;
    apiParams['urlParms']['tags'] = `similar`;
    apiParams['urlParms']['product'] = currentProductId;
    apiParams['urlParms']['limits'] = 10;
    callSearchSpringAPI(apiParams);
    callSearchSpringCommonAPI();
  break;

  default:
    callSearchSpringCommonAPI();
}
